const PropTypes = require('prop-types');
/* eslint-disable react/jsx-no-bind */

// @ vendors
const React = require('react');
const { connect } = require('react-redux');
const classNames = require('classnames');
const Immutable = require('immutable');
const get = require('lodash/object/get');
const moment = require('moment');
const padLeft = require('lodash/string/padLeft');

// @ actions
const commercialAdsAction = require('actions/commercialInterstitialsAds');
const contractsActions = require('actions/contracts');
const hireDepositThirteenMonths = require('actions/hireDepositThirteenMonths');
const hireNewMoneyDeposit = require('actions/hireNewMoneyDeposits');
const hireNoNewMoneyDeposit = require('actions/hireNoNewMoneyDeposits');
const hireDepositEighteenMonths = require('actions/hireDepositEighteenMonths');
const hiringProductInformation = require('actions/hiringProductInformation')
const intervenersActions = require('actions/getAccountInterveners');
const termsAndCondsLegalWindowActions = require('actions/termsAndCondsLegalWindow');
const hireMainNoNewMoneyDeposit = require('actions/hireDepositNoNewMoney');
import okApiDocuments from 'actions/okApiDocuments';

// @ commons
const { formatText, FormattedText, hasTranslation } = require('core/i18n').i18n;
const { OKButton } = require('components/commons/OKButton/OKButton');
const { OKLink } = require('commonsComponents/OKLink');
const OKSelect = require('components/commons/OKSelect/OKSelect');
const DatePickerCustom = require('components/datePickerCustom/datePickerCustom');
const { OKCheckbox } = require('commonsComponents/OKCheckbox');
const { RadioButtonGroup } = require('commonsComponents/radioButtonGroup');
const { RadioButton } = require('commonsComponents/radioButton');
const { InputSafe } = require('commonsComponents/inputSafe');
const SuggestList = require('components/commons/suggestList/SuggestList');
const OKModal = require('components/commons/OKModal/OKModal');
const TabbedBox = require('components/commons/tabbedBox/tabbedBox');
const MaskedAmount = require('components/maskedAmount/maskedAmount');
const OKInformativeList = require('components/rebrand/OKInformativeList/OKInformativeList');
const OKInformativeListItem = require('components/rebrand/OKInformativeListItem/OKInformativeListItem');
const { LoadingSection } = require('commonsComponents/loadingSection');
const { OKMessage } = require('commonsComponents/OKMessage');
const OKTooltip = require('components/commons/OKTooltip/OKTooltip');
const { EmptyState } = require('commonsComponents/emptyState');

//Components Contrataciones
const InputIban = require('../InputIban/InputIban');
const FullName = require('../FullName/FullName');
const ContractSlider = require('../contractSlider/contractSlider');
const ContractDropdownAccount = require('../contractDropdownAccount/contractDropdownAccount');
const ContractDropdownDeposit = require('../ContractDropdownDeposit/contractDropdownDeposit');
const ContractLabelDeposit = require('../ContractLabelDeposit/contractLabelDeposit');
const ContractInformation = require('../ContractInformation/ContractInformation');
const TaxAdditionalCountryForm = require('components/myProfile/taxAdditionalCountryList/taxAdditionalCountryForm');
const ContractAccordion = require('../ContractAccordion/ContractAccordion');
const GridForm = require('../GridForm/GridForm');
const Fioc = require('../Fioc/Fioc');
const CustomErrorMessage = require('../CustomErrorMessage/CustomErrorMessage');
const ContractInput = require('../contractInput/contractInput');
const TaxData = require('../TaxDataSelect/TaxDataContainer/TaxData');
const PoliticalCharge = require('../PoliticalCharge/PoliticalCharge/PoliticalCharge');
const OwnMoneySelect = require('../OwnMoneyAccount/OwnMoneyAccount/OwnMoneyAccount');
const ForeignTax = require('../ForeignTax/ForeignTax/ForeignTax');
const Holders = require('../Holders/Holders');
const LaboralData = require('../LaboralData/LaboralData');
const AddHolder = require('../LaboralData/AddHolder/AddHolder');
const AddPromotionalCode = require('../AddPromotionalCode/AddPromotionalCode');
const MethodOfPayment = require('../MethodOfPayment/MethodOfPayment');
const CreditLimitSelection = require('../creditLimitSelection/creditLimitSelection');
const ImportAmountInput = require('../ImportAmountInput/ImportAmountInput');
const InvestmentFundList = require('../InvestmentFundList/InvestmentFundList');
const ValidationModal = require('../ValidationModal/ValidationModal');
const InformationModal = require('../InformationModal/InformationModal');
const FiocProfession = require('../FiocProfession/FiocProfession');
const { InterestBand } = require('../InterestBand/interestBand');
const { ContractDisclaimerPersonalInfo } = require('../ContractDisclaimerPersonalInfo/ContractDisclaimerPersonalInfo');
const HiringProductInformation = require('components/hiringProductInformation/hiringProductInformation');
const { HireCardImageSelector } = require('components/hire/hireCardImageSelector/hireCardImageSelector');
const { HireCardPinSet } = require('components/hire/hireCardPinSet/hireCardPinSet');
const PreContractualDocumentViewer = require('components/commons/preContractualDocumentViewer/preContractualDocumentViewer');
const Step1DepositTransfer = require('../Step1DepositTransfer/Step1DepositTransfer');
const Step1ContractSavings = require('../Step1ContractSavings/Step1ContractSavings');

// @ Contracts helpers
const formHelper = require('../../utilities/formHelper');
const formValidationHelper = require('../../utilities/formValidationHelper');
const inputsValidationHelper = require('../../utilities/inputsValidationHelper');
const { findElementbyId } = require('../../utilities/contractStateHelper');
const { recordLink } = require("utilities/tagging");
const { 
    fiocSelctKnowYourCNAE,
    fiocSelectProfessionTagging,
    fiocForeignTaxErrorTagging,
    fiocSelectTagging,
    fiocSelectClickTagging,
    fiocSelectEconomicActivityTagging,
    fiocOKSelectClickTagging,
    fiocCheckboxTagging,
    fiocTooltipHasPepTagging,
    fiocPepNameTagging,
    fiocFiscalCountryCloseTagging,
    fiocFiscalCountryOpenTagging,
    fiocFiscalCountryClickTagging,
    customCheckboxErrorFiocTagging,
    fiocErrorTagging
} = require('utilities/taggingInfo/fiocTags');
// @ Project helpers
const DateHelper = require('utilities/dateHelper');
const { formatAmount, formatInterest } = require('utilities/currencyHelper');
const { COUNTRIES_CODES: { NL } } = require('constants/countries');
import { getIsFullProfitability } from 'utilities/depositHelper'

// @ constants
const {
    ACCOUNT_INTERVENTION_AUTHORIZED_CODE,
    ACCOUNT_INTERVENTION_OWNER_CODE,
    ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE,
    CARD_PAYMENT_METHOD_FIXED,
    CARD_PAYMENT_METHOD_UNIQUE,
    CARD_PAYMENT_METHOD_VARIABLE,
    DEFAULT_COUNTRY,
    DOCUMENT_TYPE_NIF_LENGTH,
    DOCUMENT_TYPE_NIF,
    EURO_SYMBOL,
    PHONE_NUMBER_MAX_LENGTH,
    SPAIN_COUNTRY_CODE,
    CONTRACT_INDEX_DEPOSIT_NEW_MONEY,
    CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY,
    CONTRACT_INDEX_DEPOSIT_TRANSFER,
    CONTRACT_INDEX_DEPOSIT_RENEWAL,
    CONTRACT_INDEX_DEPOSIT_EXPIRATION,
    CONTRACT_INDEX_DEPOSIT_PAYROLL,
} = require('constants/index');
const {
    PRODUCT_TYPE_ACCOUNT,
    PRODUCT_HIRING_COMPONENT_ID
} = require('constants/hiringProductInformation');
const { contractsValidationsErrorMessages } = require('constants/contractsValidations');
const {
    DATE_PICKER_CUSTOM_PLACEHOLDER,
    DATE_PICKER_CUSTOM_LOCALE,
    DATE_PICKER_CUSTOM_DATE_FORMAT
} = require('constants/commonsComponents');
const contractBuilder = require('../../libs/contractBuilder');
const {
    GC,
    R42_TRAVEL_PLUS_OFF_HIRING,
    NEW_PLASTIC_MAESTRO,
    DEPOSITS_INTEREST_BAND_COUNTRIES,
} = require('constants/flagBasedFeatures');
const { LINK_CLICK_ACTION_EVENT, DEPOSIT_NEW_MONEY, DEPOSIT_WITHOUT_NEW_MONEY, DEFERRAL_DEPOSIT_INPUT_ERROR_CATEGORY, DEPOSIT_BONIFIED_WITHOUT_NEW_MONEY } = require('constants/tagging');
//@contactCenter
const LegalConfirmation = require('../../components/LegalConfirmation/LegalConfirmation');
const { isPrintOfficeMode } = require('utilities/contactCenter/printerHelper');
import { isAContractThatNeedsHydration } from '../../isAContractThatNeedsHydration'
import { DocumentationViewer } from '../documentation/DocumentationViewer';
import precontractualActions from 'actions/preContractualPolling';

class ContractComponent extends React.Component {
    constructor(props) {
        super(props);

        this.handleRadioButtonChange = this.handleRadioButtonChange.bind(this);
        this.buildCheckbox = this.buildCheckbox.bind(this);
        this.handleAfterChange = this.handleAfterChange.bind(this);
        this.onHandleMethodOfPaymentDataReceiver = this.onHandleMethodOfPaymentDataReceiver.bind(
            this
        );
        this.handleSelectedCard = this.handleSelectedCard.bind(this);
        this.doBuild - this.doBuild.bind(this);
        this.handleAddTaxCountry = this.handleAddTaxCountry.bind(this);
        this.handleDeleteTaxCountry = this.handleDeleteTaxCountry.bind(this);
        this.handleCloseHolderModal = this.handleCloseHolderModal.bind(this);
        this.handleOpenHolderModal = this.handleOpenHolderModal.bind(this);
        this.handleRemoveHolder = this.handleRemoveHolder.bind(this);
        this.onHandleFullNameReceiver = this.onHandleFullNameReceiver.bind(this);
        this.onHandleInputIbanReceiver = this.onHandleInputIbanReceiver.bind(this);
        this.onHandleTaxDataReceiver = this.onHandleTaxDataReceiver.bind(this);
        this.onHandleOwnMoneyReceiver = this.onHandleOwnMoneyReceiver.bind(this);
        this.onHandlePoliticalChargeReceiver = this.onHandlePoliticalChargeReceiver.bind(this);
        this.onHandleLaboralDataReceiver = this.onHandleLaboralDataReceiver.bind(this);
        this.onHandleAddHolderDataReceiver = this.onHandleAddHolderDataReceiver.bind(this);
        this.onHandleAddPromotionalCodeDataReceiver = this.onHandleAddPromotionalCodeDataReceiver.bind(
            this
        );
        this.onHandleInvestmentListDataReceiver = this.onHandleInvestmentListDataReceiver.bind(
            this
        );
        this.onHandleCreditLimitSelectionDataReceiver = this.onHandleCreditLimitSelectionDataReceiver.bind(
            this
        );
        this.onHandleContractDataReceiver = this.onHandleContractDataReceiver.bind(this);
        this.onAfterChange = this.onAfterChange.bind(this);
        this.handleShowFiocTest = this.handleShowFiocTest.bind(this);
        this.handlePersonalInfoDisclaimerCheck = this.handlePersonalInfoDisclaimerCheck.bind(this);
        this.handleMoreInfoClick = this.handleMoreInfoClick.bind(this);
        this.handleRequestInterestBand = this.handleRequestInterestBand.bind(this);
        this.getLegalText = this.getLegalText.bind(this);
    }

    componentWillReceiveProps(nextProps) {
        const {
            contractWizard: immNextContractWizard,
            updateCardDetails,
        } = nextProps;

        if (immNextContractWizard.get('name_contract') === 'junior-account') {
            const {
                contractWizard: immCurrentContractWizard,
                localState: { card_details: currentCardDetails },
            } = this.props;
            const nextCardOwner = currentCardDetails.find(item => item.id === 'juniorAccount_cardOwner').value;

            if (immNextContractWizard.getIn(['openYoungProfileDetails', 'fetched']) &&
                !immCurrentContractWizard.getIn(['openYoungProfileDetails', 'fetched']) &&
                nextCardOwner === 'loading') {
                const cardDetails = contractBuilder.juniorAccount_loadCardOwnerInfoInForms(currentCardDetails, immNextContractWizard.getIn(['openYoungProfileDetails', 'info']));
                updateCardDetails(cardDetails);
            }
        }
    }

    componentDidUpdate(prevProps) {
        const {
            contractWizard,
            hireAccountPassportOrFutureMode,
            isSetPinEnabled,
            localState,
            updateCardDetails,
        } = this.props;

        const { contractWizard: prevContractWizard } = prevProps;

        if (['deposit', 'depositnm', 'deposittransfer', 'depositrenewal', CONTRACT_INDEX_DEPOSIT_EXPIRATION, CONTRACT_INDEX_DEPOSIT_PAYROLL].includes(contractWizard.get('name_contract'))) {
            if (prevContractWizard.getIn(['interest', 'calculatedInterest']) !== contractWizard.getIn(['interest', 'calculatedInterest'])) {
                const interest = contractWizard.getIn(['interest', 'calculatedInterest']);
                const grossInterest = localState.card_details.find((element) => element.id === 'gross_interest') || {};
                grossInterest.value = interest;
                updateCardDetails(localState.card_details);
            }
        }

        if (['checking-account', 'payroll-account'].includes(contractWizard.get('name_contract'))) {
            const passportOrFutureMode = localState.card_details.find(item => item.id === 'passport_or_future_mode');

            if (!!passportOrFutureMode && passportOrFutureMode.value !== hireAccountPassportOrFutureMode) {
                const isSetPin = localState.card_details.find(item => item.id === 'card_pin_change');

                let modCardDetails = localState.card_details;

                modCardDetails.find(item => item.id === 'passport_or_future_mode').value = hireAccountPassportOrFutureMode;

                if (!!isSetPin && isSetPin.isEnabled !== isSetPinEnabled) {
                    modCardDetails.find(item => item.id === 'card_pin_change').isEnabled = isSetPinEnabled;
                }

                updateCardDetails(modCardDetails);
            }
        }

        this.handleRequestInterestBand(prevProps)
    }

    handleOnFocus = () => {
        fiocFiscalCountryClickTagging();
        fiocFiscalCountryOpenTagging();
    }

    handleRequestInterestBand (prevProps) {
        const { requestDepositsInterest } = this.props
        const { contractWizard: prevContractWizard, localState: { card_details: prevCardDetails } } = prevProps
        const { contractWizard: nextContractWizard, localState: { card_details: nextCardDetails } = {} } = this.props

        if (!nextContractWizard) return

        const prevRate = prevContractWizard.getIn(['deposit_product', 'tin'])
        const nextRate = nextContractWizard.getIn(['deposit_product', 'tin'])
        const prevMonths = prevContractWizard.getIn(['deposit_product', 'months'])
        const nextMonths = nextContractWizard.getIn(['deposit_product', 'months'])

        const prevAmountToTransfer = prevCardDetails && (prevCardDetails.find((element) => element.id === 'monto_traspasar') || {}).value;
        const nextAmountToTransfer = nextCardDetails && (nextCardDetails.find((element) => element.id === 'monto_traspasar') || {}).value;

        if ((prevRate && nextMonths) && (prevRate !== nextRate || prevMonths !== nextMonths || prevAmountToTransfer !== nextAmountToTransfer)) {
            requestDepositsInterest({
                rate: nextRate,
                months: nextMonths,
                amount: nextAmountToTransfer,
            });
        }
    }

    onAfterChange(component, value) {
        const { updateCardDetails, localState: { card_details: cardDetails } } = this.props;

        const newCardDetails = [...cardDetails]

        // Call function:
        //values is an array with object target - value
        let val = value.target ? value.target.value : value;
        if (component.inputType != 'float') {
            val = Number.isNaN(val) ? '' : String(val).replace(/\./g, '');
        }
        const values = contractBuilder[component.onChangeFn](val, component, cardDetails);
        values.forEach(item => {
            const cardDetailInputIndex = newCardDetails.findIndex(element => element.id === item.target)
            if (cardDetailInputIndex > -1) {
                const newCardDetailInput = {...newCardDetails[cardDetailInputIndex], value: item.value}
                newCardDetails.splice(cardDetailInputIndex, 1, newCardDetailInput)
            }
        });

        updateCardDetails(newCardDetails);
    }

    onChangeCheckbox(component, event) {
        const { updateCardDetails, contractWizard, localState } = this.props;
        const { card_details: cardDetails } = localState;

        if (component.uncheckElements) {
            component.uncheckElements.map(element => {
                if (event.target.checked) {
                    cardDetails.find(detail => detail.id === element).value = false;
                }
                return element;
            });
            this.setState(cardDetails);
        }

        const eventState = contractBuilder[component.onChangeFn](cardDetails, component, event);
        formValidationHelper.validateComponent(
            eventState,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );
        updateCardDetails(eventState);
        event.target.checked && fiocCheckboxTagging(component)
    }

    onHandleAddHolderDataReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data.component_id).value = data;
    }

    onHandleAddPromotionalCodeDataReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data.component_id).value = data;
    }

    onHandleContractDataReceiver(data) {
        const { updateCardDetails } = this.props;
        this.props.localState.card_details.find(x => x.id === data[0].component_id).value = data;
        updateCardDetails(this.props.localState.card_details);
    }

    onHandleCreditLimitSelectionDataReceiver(data) {
        const {
            contractWizard,
            updateCardDetails,
            localState: { card_details: cardDetails }
        } = this.props;
        const maxApprovedLimit = contractWizard.get('maxLimitToAuthorize') || 0;
        const userSelectedLimit = cardDetails.find(x => x.id === 'creditLimit').value;
        const creditLimitValue = data ? maxApprovedLimit : userSelectedLimit;

        cardDetails.find(x => x.id === 'creditLimit').value = creditLimitValue;
        cardDetails.find(x => x.id === 'creditLimitSelection').openModal = false;
        updateCardDetails(cardDetails);
    }

    onHandleForeignTaxReceiver(component, data) {
        const { updateCardDetails, localState } = this.props;
        const cardDetails = localState.card_details;
        cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.id).value = data;
        updateCardDetails(cardDetails);
    }

    onHandleFullNameReceiver(component, data) {
        const { updateCardDetails, localState } = this.props;
        const cardDetails = localState.card_details;

        cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.id).value = data;
        updateCardDetails(cardDetails);
    }

    onHandleHoldersReceiver(component, data) {
        const { updateCardDetails, localState } = this.props;
        const prefix = component.prefix;
        let cardDetails = localState.card_details;
        let holdersPersonalInfoDisclaimer = cardDetails.find(
            component => component.id === 'holders-personal-info-disclaimer'
        );

        if (holdersPersonalInfoDisclaimer !== undefined) {
            holdersPersonalInfoDisclaimer.required = data[0];//data[0] refers to the value of the radio button to add holders or not
        }

        cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.id).value = data;
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.id
        ).isErrorVisible = null;

        cardDetails = this.updatePersonalData(data[1], cardDetails, prefix);

        updateCardDetails(cardDetails);
    }

    handlePersonalInfoDisclaimerCheck(event) {
        const {
            updateCardDetails,
            localState: { card_details: cardDetails }
        } = this.props;

        cardDetails.find(component => component.id === 'holders-personal-info-disclaimer').value = event.target.checked;
        updateCardDetails(cardDetails);
    }

    onHandleInputIbanReceiver(component, data) {
        const {
            updateCardDetails,
            contractWizard,
            localState: { card_details: cardDetails }
        } = this.props;

        cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.id).value = data;
        formValidationHelper.validateComponent(
            cardDetails,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );

        updateCardDetails(cardDetails);
    }

    onHandleInvestmentListDataReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data.component_id).value = data;
    }

    onHandleLaboralDataReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data[0].component_id).value = data;
    }

    onHandleMethodOfPaymentDataReceiver(component, data) {
        const {
            updateCardDetails,
            localState: { card_details: cardDetails, showTinTae }
        } = this.props;
        const isElementValid = {
            errorMessage: false,
            element: formHelper.getField(cardDetails, component)
        };

        if (showTinTae) {
            this.setTINandTAE(data.methodOfPayment, cardDetails);
        }

        this.setMethodOfPayment(cardDetails, data);
        cardDetails.find(cardDetailsItem => cardDetailsItem.id === 'methodOfPayment').value = data;
        inputsValidationHelper.updateCardDetailElementError(isElementValid);
        updateCardDetails(cardDetails);
    }

    onHandleOwnMoneyReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data.component_id).value = data;
    }

    onHandlePoliticalChargeReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data.component_id).value = data;
    }

    onHandleTaxDataReceiver(data) {
        this.props.localState.card_details.find(x => x.id === data[0].component_id).value = data;
    }

    getProfessionCnaeList() {
        const { contractWizard } = this.props;
        let professionCnaeList = [];

        contractWizard.get('professionCnae').map(function (value) {
            let professions = {};
            professions.category = value.get('category');
            professions.subCategory = value.get('subCategory');
            professions.items = [];

            value.get('items').map(function (value) {
                professions.items.push({
                    name: value.get('name'),
                    code: value.get('code')
                });
            });

            professionCnaeList.push(professions);
        });

        return professionCnaeList;
    }

    getProfessionCnaeListOrCategories(categories = false) {
        const list = categories ? 'professionCnaeCategoryItems' : 'professionCnaeUncategorized';
        return this.props.contractWizard.get(list).toJS();
    }

    getProfessionCnoList(privateList) {
        const { contractWizard } = this.props;
        const usePrivate = privateList ? 'professionCnoPrivate' : 'professionCno';
        let getProfessionCnoList = [];
        contractWizard.get(usePrivate).map(function (value) {
            getProfessionCnoList.push(value.toObject());
        });
        return getProfessionCnoList;
    }

    setMethodOfPayment(cardDetails, data) {
        const {
            fixedFeeAmount,
            inputFormat,
            methodOfPayment,
            percentageAmount
        } = data;
        const values = {
            methodOfPayment: {
                [CARD_PAYMENT_METHOD_UNIQUE]: `${formatText('contractsView-methodOfPaymentFullPay')}`,
                [CARD_PAYMENT_METHOD_FIXED]: `${formatText('contractsView-methodOfPaymentDeferredFixedFee')}`,
                [CARD_PAYMENT_METHOD_VARIABLE]: `${formatText('contractsView-methodOfPaymentDeferredVariableFee')}`
            },
            feeAmount: {
                [CARD_PAYMENT_METHOD_UNIQUE]: '',
                [CARD_PAYMENT_METHOD_FIXED]: `${formatAmount(fixedFeeAmount)} ${inputFormat}`,
                [CARD_PAYMENT_METHOD_VARIABLE]: `${percentageAmount} ${inputFormat}`
            }
        };
        const feeAmount = cardDetails.find(cardDetailsItem => cardDetailsItem.id === 'feeAmount');

        if (methodOfPayment === CARD_PAYMENT_METHOD_FIXED || methodOfPayment === CARD_PAYMENT_METHOD_VARIABLE) {
            feeAmount.visible = feeAmount.visibleValue;
        } else {
            feeAmount.visible = [];
        }


        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === 'methodOfPaymentTitle'
        ).value = values.methodOfPayment[methodOfPayment];
        feeAmount.value = values.feeAmount[methodOfPayment];
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === 'fullMethodOfPayment'
        ).value = `${values.methodOfPayment[methodOfPayment]} ${values.feeAmount[methodOfPayment]}`;
    }

    setTINandTAE(methodOfPayment, cardDetails) {
        const tin = cardDetails.find(cardDetailsItem => cardDetailsItem.id === 'tin');
        const tae = cardDetails.find(cardDetailsItem => cardDetailsItem.id === 'tae')

        if (methodOfPayment === CARD_PAYMENT_METHOD_FIXED || methodOfPayment === CARD_PAYMENT_METHOD_VARIABLE) {
            tin.visible = tin.visibleValue;
            tae.visible = tae.visibleValue;
        } else {
            tin.visible = [];
            tae.visible = [];
        }
    }

    buildAmountInput(component) {
        return (
            <div className="ok-slider">
                <div className="ok-slider__text">
                    <FormattedText value={component.label} />
                </div>
                <div className="ok-slider__slider-box">
                    {this.buildSingleAmountInput(component, component.type === 'form')}
                </div>
            </div>
        );
    }

    buildCheckbox(component) {
        const { contractWizard } = this.props;
        const immCardDetails = contractWizard.get('card_details');
        let label;
        if (component.labelElements !== undefined) {
            label = component.labelElements.map((element, index) => {
                let block;
                switch (element.type) {
                    case 'line-break':
                        block = <br key={index} />;
                        break;
                    case 'text':
                        block = (
                            <FormattedText
                                className="contract-view__checkbox-label-block"
                                key={index}
                                value={element.textKey}
                            />
                        );
                        break;
                    case 'link':
                        const url = formatText(element.urlKey);
                        block = (
                            <OKLink
                                extraClass="contract-view__checkbox-label-block"
                                key={index}
                                modifier={element.modifier}
                                target="_blank"
                                to={url}
                            >
                                <FormattedText value={element.textKey} />
                            </OKLink>
                        );
                        break;
                }
                return block;
            });
        } else {
            label = formatText(component.label);
        }
        const value = findElementbyId(immCardDetails, component.id);
        const error = formValidationHelper.getErrorMessage(immCardDetails, component);
        return (
            <OKCheckbox
                idName={component.id}
                value={value || false}
                onChange={this.onChangeCheckbox.bind(this, component)}
                label={label}
                buildComponent={this.doBuild.bind(this)}
                errorState={!component.validateGroup && error.state}
                errorMessage={error.message}
            />
        );
    }

    buildCombo(component) {
        const { extraClasses } = component;
        const className = classNames(extraClasses, 'contract-input');
        const combo = this.buildSingleCombo(component);

        return <div className={className}>{combo}</div>;
    }

    buildContentTabs(component) {
        let holderComponents = [],
            auxiliarComponents = [],
            holderTab = [],
            auxiliarTab = [];

        //Set Auxiliar components
        component.content.forEach(item => {
            auxiliarComponents.push(this.buildComponent(item));
        });

        let originalHolderComponents = component.content;

        originalHolderComponents.forEach(pitem => {
            pitem.grid.forEach(subItems => {
                subItems.forEach(item => {
                    if (component.exclude.includes(item.id)) {
                        subItems.splice(item);
                    }
                });
            });
        });

        //Set Holder components
        originalHolderComponents.forEach(item => {
            holderComponents.push(this.buildComponent(item));
        });

        //Build Secondary Tabs
        //Build holder (titulares)
        const holderCount = 3;
        const auxiliarCount = 2;
        for (let i = 0; i < holderCount; i++) {
            holderTab.push({
                label: 'Por definir',
                content: (
                    <div>
                        {holderComponents}
                    </div>
                )
            });
        }
        //Build auxiliar (Avalistas)
        for (let i = 0; i < auxiliarCount; i++) {
            auxiliarTab.push({
                label: 'Por definir',
                content: (
                    <div>
                        {auxiliarComponents}
                    </div>
                )
            });
        }
        //Build Principal Tabs
        const principalTabs = [
            {
                label: `Titulares (${holderCount})`,
                content: <TabbedBox id="brokerIndexes" tabs={holderTab} />
            },
            {
                label: `Avalistas (${auxiliarCount})`,
                content: <TabbedBox id="brokerIndexes" tabs={auxiliarTab} />
            }
        ];
        return principalTabs;
    }

    buildDateTimePicker(component) {
        const maxDate = component.maxDate
            ? component.maxDate === 'today'
                ? moment()
                : moment().subtract(component.maxDate.amount, component.maxDate.type)
            : null;
        const minDate = component.minDate
            ? moment().startOf('day').subtract(component.minDate.amount, component.minDate.type).add(1, 'days')
            : null;

        const { contractWizard, localState } = this.props;
        let selectedValue = moment();
        const label = formatText(component.label);
        let disabledField = false;

        const immCardDetails = contractWizard.get('card_details');
        const error = formValidationHelper.getErrorMessage(immCardDetails, component);
        const target =
            component.type === 'form'
                ? findElementbyId(immCardDetails, component.target)
                : immCardDetails;
        const element = target.find(map => map.get('id') === component.id);
        const cardDetailsComponent = localState.card_details.find(item => item.id === component.id);
        const isJuniorAccount = contractWizard.get('name_contract') === 'junior-account';
        let messageLessThanMinDateError;
        let messageMoreThanMinDateError;
        let forceErrorMessageShow = false;
        let forceErrorMessageText = '';

        if (['checking-account', 'payroll-account'].includes(contractWizard.get('name_contract').toLowerCase())) {
            forceErrorMessageShow = element.get('isErrorVisible');
            forceErrorMessageText = formatText('contractsView-requiredDateErrorCheckingPayroll');
        }

        if (element) {
            selectedValue = moment(element.get('value')).isValid() && element.get('value') !== null
                ? moment(element.get('value'))
                : null;
        }


        if ('disabled' in component || isJuniorAccount) {
            disabledField = !!cardDetailsComponent ? cardDetailsComponent.disabled : component.disabled;
        }

        if (isJuniorAccount) {
            messageLessThanMinDateError = (
                <FormattedText
                    className="contract-view__date-picker-error"
                    value="contractsView-messageLessThanMinDateError"
                />
            );
            messageMoreThanMinDateError = (
                <FormattedText
                    className="contract-view__date-picker-error"
                    value="contractsView-messageMoreThanMinDateError"
                />
            );
        }
        return (
            <div className="contract-view__input-safe">
                <DatePickerCustom
                    id={component.id}
                    label={label}
                    errorMessage={error.message}
                    callback={this.handleDateTimePickerCallback.bind(this, component)}
                    callbackError={this.handleDateTimePickerCallback.bind(this, component)}
                    maxDate={maxDate}
                    messageLessThanMinDateError={messageLessThanMinDateError}
                    messageMoreThanMinDateError={messageMoreThanMinDateError}
                    minDate={minDate}
                    selectedDate={selectedValue}
                    startDate={selectedValue}
                    disabled={disabledField}
                    placeholder={formatText(DATE_PICKER_CUSTOM_PLACEHOLDER)}
                    locale={formatText(DATE_PICKER_CUSTOM_LOCALE)}
                    dateFormat={formatText(DATE_PICKER_CUSTOM_DATE_FORMAT)}
                    forceErrorMessageShow={forceErrorMessageShow}
                    forceErrorMessageText={forceErrorMessageText}
                />
            </div>
        );
    }

    buildFullName(component) {
        const { contractWizard, localState: { card_details: cardDetails } } = this.props;
        const errorMessage = component.msg_error ? formatText(component.msg_error) : null;
        const element = cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.id);
        const value = element.value || { firstName: '', lastName: '', secondlastName: '' };
        const immCardDetails = contractWizard.get('card_details');

        const errorsState = immCardDetails
            ? findElementbyId(immCardDetails, component.id, 'isErrorVisible')
            : [false, false, false];

        return (
            <div className="row">
                <FullName
                    value={value}
                    id={component.id}
                    regex={component.regex}
                    errorState={errorsState}
                    errorMessage={errorMessage}
                    dataReceiver={this.onHandleFullNameReceiver.bind(this, component)}
                    updateSimpleIntervener={this.props.updateSimpleIntervener}
                />
            </div>
        );
    }

    buildInformativeList(component) {
        const informativeListItems = contractBuilder[component.source]().map(item => {
            return (
                <OKInformativeListItem
                    key={item.title}
                    title={item.title}
                    bodyText={item.bodyText}
                />
            );
        });

        return (
            <OKInformativeList columns={informativeListItems.length}>
                {informativeListItems}
            </OKInformativeList>
        );
    }

    buildInputIban(component) {
        const { contractWizard, localState } = this.props;
        const errorMessageRequiredIbanOption = component.msg_error
            ? formatText(component.msg_error)
            : null;
        const errorMessageRequiredIbanValue = formatText(
            contractsValidationsErrorMessages.ERROR_MESSAGE_IBAN_REQUIRED
        );
        const errorMessageRequiredIbanNotValid = formatText(
            contractsValidationsErrorMessages.ERROR_MESSAGE_IBAN_NOT_VALID
        );
        const element = localState.card_details.find(
            cardDetailsItem => cardDetailsItem.id === component.id
        );
        const label = component.label ? formatText(component.label) : '';
        const labelYes = component.labelYes ? formatText(component.labelYes) : '';
        const labelNo = component.labelNo ? formatText(component.labelNo) : '';
        const value = element.value || ['', ['', '', '', '', '', '']];

        let errorsState = [false, false];
        if (contractWizard.get('card_details')) {
            errorsState = contractWizard
                .get('card_details')
                .filter(cardDetailsItem => cardDetailsItem.get('id') === component.id)
                .get(0)
                ? contractWizard
                    .get('card_details')
                    .filter(cardDetailsItem => cardDetailsItem.get('id') === component.id)
                    .get(0)
                    .get('isErrorVisible')
                : [false, false];

            if (!errorsState) {
                errorsState = [false, false];
            }
        }

        return (
            <div>
                <InputIban
                    label={label}
                    labelYes={labelYes}
                    labelNo={labelNo}
                    value={value}
                    id={component.id}
                    errorState={errorsState}
                    errorMessageRequiredIbanValue={errorMessageRequiredIbanValue}
                    errorMessageRequiredIbanOption={errorMessageRequiredIbanOption}
                    errorMessageRequiredIbanNotValid={errorMessageRequiredIbanNotValid}
                    dataReceiver={this.onHandleInputIbanReceiver.bind(this, component)}
                />
            </div>
        );
    }

    buildOKButton(component) {
        const {
            className: componentClassName,
            icon,
            label,
            labelClassName,
            modifier: componentModifier,
        } = component;
        const handler = this.handleOKButtonClick.bind(this, component);
        const className = classNames('ok-slider', {
            [componentClassName]: componentClassName
        });
        const childrenLabel = <FormattedText value={label} className={labelClassName} />;
        const modifier = componentModifier || 'link-emphasize';

        return (
            <div className={className}>
                <OKButton
                    disabled={false}
                    typeButton="bs"
                    modifier={modifier}
                    children={childrenLabel}
                    onClick={handler}
                    leftIcon={icon}
                />
            </div>
        );
    }

    getFormartedAmount (amount) {
        const amountFormatted = formatInterest(amount, false)
        return `${amountFormatted} ${EURO_SYMBOL}`
    }

    getLegalText(component) {
        if (!!component.legal_text) {
            return {
                uniqueLegalKey: component.legal_text,
                uniqueLegalValues: []
            }
        }
        return {
            uniqueLegalKey: null,
            uniqueLegalValues: []
        }
    }

    buildLegalConfirmation(component) {
        const {
            contractWizard,
            immProfileFields,
            getDocumentsOkApiById,
            updateConfirmationCheckboxes,
            sendPreContractualMail,
            preContractualMail,
            requestProfile,
            current_contract,
            gestorCrossEnabled,
            immHiringProductInformation,
            setTermsAndCondsText,
            onLegalTextRead,
            preContractualMailPolling,
            match,
            getPrecontractualDocumentURLOrID,
        } = this.props;
        const productName = current_contract.productName ? formatText(current_contract.productName) : undefined;
        const depositProduct = current_contract.state.deposit_product;
        const { uniqueLegalKey, uniqueLegalValues } = this.getLegalText(component);
        const type = depositProduct && depositProduct.type ? depositProduct.type : current_contract.type;
        const subtype = depositProduct && depositProduct.subtype ? depositProduct.subtype : current_contract.subtype;
        const standard = depositProduct && depositProduct.standard ? depositProduct.standard : current_contract.standard;
        const alternativePositionedCheckboxes = !!current_contract.alternativePositionedCheckboxes;
        const alternativeLegalTextHeight = current_contract.alternativeLegalTextHeight;
        const customCategoryEvent = component.customCategoryEvent ? contractBuilder[component.customCategoryEvent](contractWizard) : null;
        return (
            <LegalConfirmation
                contractBuilder={contractBuilder}
                alternativePositionedCheckboxes={alternativePositionedCheckboxes}
                alternativeLegalTextHeight={alternativeLegalTextHeight}
                documentId={contractWizard.get('precontractualDocumentId')}
                getDocumentsOkApiById={getDocumentsOkApiById}
                wizardState={contractWizard}
                confirmationCheckboxes={contractWizard.get('confirmationCheckboxes')}
                gestorCrossEnabled={gestorCrossEnabled}
                immProfileFields={immProfileFields}
                immHiringProductInformation={immHiringProductInformation}
                updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                sendPreContractualMail={sendPreContractualMail}
                preContractualMailPolling={preContractualMailPolling}
                onLegalTextRead={onLegalTextRead}
                requestProfile={requestProfile}
                preContractualMail={preContractualMail}
                subType={subtype}
                type={type}
                standar={standard}
                productName={productName}
                uniqueLegalKey={uniqueLegalKey}
                uniqueLegalValues={uniqueLegalValues}
                setTermsAndCondsText={setTermsAndCondsText}
                hasPolling={!!current_contract.hasPolling}
                currentProduct={current_contract.product}
                biggerLegalTexts={!!current_contract.biggerLegalTexts}
                emailInfo={current_contract.emailInfo}
                customCategoryEvent={customCategoryEvent}
                match={match}
                getPrecontractualDocumentURLOrID={getPrecontractualDocumentURLOrID}
                component={component}
            />
        );
    }

    buildPhoneLine(component) {
        let disabled = false;
        const { contractWizard, localState } = this.props;
        const immCardDetails = contractWizard.get('card_details');
        const error = formValidationHelper.getErrorMessage(immCardDetails, component);
        const target =
            component.type === 'form'
                ? findElementbyId(immCardDetails, component.target)
                : immCardDetails;
        const phone_prefix = `+${SPAIN_COUNTRY_CODE}`;
        let value = !!target ? findElementbyId(target, component.id) || component.default_value : '';

        if (contractWizard.get('name_contract') === 'junior-account') {
            const cardDetailsComponent = localState.card_details.find(item => item.id === component.id);
            if (!!cardDetailsComponent) {
                value = value || cardDetailsComponent.value;
                disabled = cardDetailsComponent.disabled;
            }
        }

        return (
            <div className="ok-input">
                <label className="ok-select__label">
                    <FormattedText value={component.label} />
                </label>
                <div className="contract-view__phone-line">
                    <div className="col-xs-2">
                        <InputSafe value={phone_prefix} disabled={true} type="text" />
                    </div>
                    <div className="col-xs-6">
                        <InputSafe
                            disabled={disabled}
                            label={null}
                            name={component.id}
                            onKeyPress={this.handleRegexOnKeyPressAndPaste.bind(this, component)}
                            maxLength={PHONE_NUMBER_MAX_LENGTH}
                            onPaste={this.handleRegexOnKeyPressAndPaste.bind(this, component)}
                            onBlur={this.handleBlur.bind(this, component)}
                            onChange={this.handleInputChange.bind(this, component)}
                            referenceName={component.id}
                            type={component.type_format}
                            value={value}
                            errorState={error.state}
                            errorMessage={error.message}
                        />
                    </div>
                </div>
            </div>
        );
    }

    buildProfessionCnae(component) {
        const { contractWizard, localState } = this.props;
        const label = component.label ? formatText(component.label) : '';
        const placeholder = component.placeholder ? formatText(component.placeholder) : '';
        const error = formValidationHelper.getErrorMessage(
            contractWizard.get('card_details'),
            component
        );

        const value = localState.card_details.filter(
            cardDetailsItem => cardDetailsItem.id === component.id
        )[0]
            ? localState.card_details.filter(
                cardDetailsItem => cardDetailsItem.id === component.id
            )[0].value
            : component.default_value;

            error.state && fiocForeignTaxErrorTagging(error.message);

        return (
            <div>
                <SuggestList
                    label={label}
                    name={component.id}
                    is={component.id}
                    placeholder={placeholder}
                    optionsList={this.getProfessionCnaeListOrCategories()}
                    onChange={this.handleChange.bind(this, component)}
                    value={value}
                    errorState={error.state}
                    errorMessage={error.message}
                    referenceName={component.id}
                    onFocus={fiocSelectClickTagging}
                />
            </div>
        );
    }

    buildProfessionCno(component) {
        const { contractWizard, localState } = this.props;
        const label = component.label ? formatText(component.label) : '';
        const placeholder = component.placeholder ? formatText(component.placeholder) : '';
        const error = formValidationHelper.getErrorMessage(
            contractWizard.get('card_details'),
            component
        );

        const value = localState.card_details.filter(
            cardDetailsItem => cardDetailsItem.id === component.id
        )[0]
            ? localState.card_details.filter(
                cardDetailsItem => cardDetailsItem.id === component.id
            )[0].value
            : component.default_value;

        return (
            <div id={component.id}>
                <SuggestList
                    label={label}
                    name={component.id}
                    is={component.id}
                    placeholder={placeholder}
                    optionsList={this.getProfessionCnoList()}
                    onChange={this.handleChange.bind(this, component)}
                    value={value}
                    errorState={error.state}
                    errorMessage={error.message}
                    referenceName={component.id}
                />
            </div>
        );
    }

    buildProfessionCurrent(component) {

        const { contractWizard, localState } = this.props;
        const label = component.label ? formatText(component.label) : '';
        const placeholder = component.placeholder ? formatText(component.placeholder) : '';
        const error = formValidationHelper.getErrorMessage(
            contractWizard.get('card_details'),
            component
        );

        const item = localState.card_details.filter(cardDetailsItem => cardDetailsItem.id === component.id);
        const value = item[0] ? item[0].value : component.default_value;

        let instructionalMessage;
        if (component.instructionalMessage) {
            instructionalMessage = (<FormattedText value={component.instructionalMessage} />);
        }

        return (
            <div>
                <OKSelect
                    placeholder={placeholder}
                    optionsList={this.getProfessionCnaeListOrCategories(true)}
                    optionalElement={instructionalMessage}
                    searchable={true}
                    label={label}
                    options={this.getProfessionCnaeListOrCategories(true)}
                    onChange={this.handleChange.bind(this, component)}
                    value={value}
                    errorState={error.state}
                    errorMessage={error.message}
                    onOpen={fiocSelectEconomicActivityTagging}
                />
            </div>
        );
    }

    buildRadioButton(item, externalDisabling) {
        const label = item.noFormatText ? item.label : formatText(item.label);
        const disabled = !!item.disabled || externalDisabling;
        return (
            <RadioButton
                label={label}
                value={item.id}
                disabled={disabled}
                key={item.id}
                className="block-step__radio"
            />
        );
    }

    // TODO: Only support one radio-button group -- harcoded right now
    buildRadioButtonGroup(component) {
        let disableItems;
        const { contractWizard, localState } = this.props;
        const cardDetails = localState.card_details;
        const options = component.source ? contractBuilder[component.source]() : component.options;
        if (contractWizard.get('name_contract') === 'junior-account') {
            const cardDetailsComponent = cardDetails.find(item => item.id === component.id)
            disableItems = !!cardDetailsComponent && cardDetailsComponent.disabled;
        }
        const radioButtons = options.map(item => this.buildRadioButton(item, disableItems));
        const default_value = options.find(option => option.id === component.default_value) || ''; // in order to set no one selected option
        const target = cardDetails.find(detail => detail.id === component.target);
        const error = formValidationHelper.getErrorMessage(cardDetails, component);
        let value;
        let tooltipContent;

        if (component.type === 'form') {
            const element = target.value.find(detail => detail.id === component.id);
            value = element ? element.value : default_value.id;
        } else {
            value = target ? target.value : default_value.id;
        }
        
        if(error.state && component.id === 'fioc_ocupation') {
            fiocErrorTagging(error.message);
        }

        const radioButtonGroup = (
            <RadioButtonGroup
                name={component.id}
                idPrefix={component.id}
                key={component.id}
                selectedValue={value}
                className="block-step__radio-group"
                value={value}
                onChange={this.handleRadioButtonChange.bind(this, component)}
                errorState={error.state}
                errorMessage={error.message}
            >
                {radioButtons}
            </RadioButtonGroup>
        );

        if (component.tooltip) {
            tooltipContent = (
                <OKTooltip
                    content={component.tooltip}
                    placement="bottom"
                    offset={[0, 15]}
                    onHover={fiocTooltipHasPepTagging}
                />
            );
        }

        return (
            <div className="ok-slider">
                <div className="ok-slider__text">
                    <FormattedText value={component.label} />{tooltipContent}
                </div>
                <div className="ok-slider__slider-box">
                    {radioButtonGroup}
                </div>
            </div>
        );
    }

    buildSectionHeader(component) {
        return (
            <h4 className="contract-view__section-header">
                <FormattedText value={component.label} />
            </h4>
        );
    }


    buildSectionSubHeader(component) {
        return (
            <h5 className="contract-view__section-sub-header">
                <FormattedText value={component.label} />
            </h5>
        );
    }

    handleMoreInfoClick() {
        const { updateCardDetails, localState: { card_details: cardDetails } } = this.props;
        const isModalOpen = cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === 'moreInfoModal'
        ).openModal;
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === 'moreInfoModal'
        ).openModal = !isModalOpen;
        updateCardDetails(cardDetails);
        recordLink(window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText('contractsView-depositNMStep2MoreInfoLink'));
    }

    buildImportAmountInput(component, amountToTransfer, maxAmount = undefined, balance = undefined) {
        const { contractWizard } = this.props;
        const subLabel = contractBuilder[component.subLabelBuildCondition](contractWizard) ? (
            <div className="contract-view__import-amount-input-sub-label">
                <FormattedText value={component.subLabel} injectedStrings={[maxAmount]} />
                <div className="contract-view__import-amount-input-moreinfolink">
                    <OKLink modifier="emphasize" onClick={this.handleMoreInfoClick}>
                        <FormattedText value="contractsView-depositNMStep2MoreInfoLink" />
                    </OKLink>
                </div>
            </div>
        ) : null;
        let inputTooltip = null;
        if (component.tooltipText) {
            let handleHover = null
            if (component.handleTooltipHover) {
                handleHover = contractBuilder[component.handleTooltipHover]
            }
            inputTooltip = (
                <OKTooltip
                    content={formatText(component.tooltipText)}
                    offset={[0, -10]}
                    type="informative"
                    onHover={() => {handleHover(contractWizard)}}
                />
            )
        }
        let categoryEvent;
        let errorCategory = '';
        if (contractWizard.get('name_contract') === 'depositnm') {
            categoryEvent = DEPOSIT_NEW_MONEY;
        } else if (contractWizard.get('name_contract') === 'deposit') {
            categoryEvent = DEPOSIT_WITHOUT_NEW_MONEY;
        } else if (contractWizard.get('name_contract') === CONTRACT_INDEX_DEPOSIT_PAYROLL) {
            categoryEvent = DEPOSIT_BONIFIED_WITHOUT_NEW_MONEY;
        } else if (contractWizard.get('name_contract') === 'deposittransfer') {
            categoryEvent = contractBuilder[component.categoryEvent](contractWizard);
        } else {
            categoryEvent = contractBuilder[component.categoryEvent](contractWizard);
            errorCategory = DEFERRAL_DEPOSIT_INPUT_ERROR_CATEGORY;
        }
        return (
            <div className="contract-view__import-amount-input">
                <div className="contract-view__label contract-view__import-amount-input-label">
                    <FormattedText value={component.label} />
                    {inputTooltip}
                </div>
                {subLabel}
                <div>
                    <ImportAmountInput
                        id="import-input"
                        component={component}
                        onChange={this.onAfterChange}
                        inputType="formatWithDecimal"
                        amountToTransfer={amountToTransfer}
                        balance={balance}
                        categoryEvent={categoryEvent}
                        errorCategory={errorCategory}
                    />
                </div>
            </div>
        );
    }

    buildSingleAmountInput(component, isFormAmountInput = false) {
        const handler = isFormAmountInput
            ? this.handleAmountChangeForm.bind(this, component)
            : this.handleAmountChange.bind(this, component);
        return (
            <MaskedAmount
                id="contract_Amount"
                min={component.importMin}
                max={component.importMax}
                error={component.amountZeroAlertVisible}
                errorMsg={component.amountErrorMsg}
                amount={component.defaultValue}
                callback={handler}
            />
        );
    }

    buildSingleCombo(component) {
        const { contractWizard, localState } = this.props;
        const { loadFromStoreField } = component;
        const options = loadFromStoreField ? contractWizard.get(loadFromStoreField).toJS() : contractBuilder[component.source](localState.card_details);
        const immCardDetails = contractWizard.get('card_details');
        const placeholder = component.placeholder ? formatText(component.placeholder) : null;
        const isCmbForm = component.type === 'form';
        const handleBlur = component.onBlurFn ? this.handleSelectOnBlur.bind(this, component) : null;
        const handler = this.handleCmb.bind(this, component);
        let disabled = component.disabled ? component.disabled : false;
        let cmbSelected;
        const error = formValidationHelper.getErrorMessage(immCardDetails, component);

        if (isCmbForm) {
            const target = findElementbyId(immCardDetails, component.target);
            cmbSelected = findElementbyId(target, component.id);
        } else {
            cmbSelected = findElementbyId(immCardDetails, component.id);
        }

        if (cmbSelected === undefined) {
            cmbSelected = findElementbyId(immCardDetails, component.id);
        }

        disabled = localState.card_details.filter(
            cardDetailsItem => cardDetailsItem.id === component.id
        )[0]
            ? localState.card_details.filter(
                cardDetailsItem => cardDetailsItem.id === component.id
            )[0].disabled
            : component.disabled;

        return (
            <OKSelect
                placeholder={placeholder}
                searchable={true}
                label={component.label}
                options={options}
                onChange={handler}
                value={cmbSelected}
                errorState={error.state}
                errorMessage={error.message}
                disabled={disabled}
                onBlur={handleBlur}
                tooltipContent={component.tooltip}
                tooltipOffset={component.tooltipOffset}
                tooltipPlacement={component.tooltipPlacement}
                onOpen={() => fiocOKSelectClickTagging(component.id)}
                />
        );
    }

    buildTabs(component) {
        return <TabbedBox id="brokerIndexes" tabs={this.buildContentTabs(component)} />;
    }

    buildTabsHolder(component) {
        const { localState } = this.props;
        const tabsHolderValue = localState.card_details.find(
            cardDetailsItem => cardDetailsItem.id === component.component_id
        ).value;
        const holders = localState.card_details.find(
            cardDetailsItem => cardDetailsItem.id === component.idComponentHolder
        ).value;
        let tabs = [];
        let items = [];
        let i = 1;
        let deleteTab = null;
        let onHandleOpenHolderModal = null;
        let top = holders[1].length;
        holders[1].map((holder, index) => {
            items = [];
            if (top > 1) {
                onHandleOpenHolderModal = this.handleOpenHolderModal.bind(this, component, index);
                deleteTab = (
                    <div className="content-remove-holder">
                        <div className="pull-right">
                            <OKButton
                                leftIcon="icon-quitar"
                                modifier="ghost"
                                onClick={onHandleOpenHolderModal}
                            >
                                <FormattedText
                                    value="contractsView-removeHolder"
                                />
                            </OKButton>
                        </div>
                    </div>
                );
                items.push(deleteTab);
            }
            if (!Array.isArray(component.tabs[`tab${i}`])) {
                items.push(this.buildComponent(component.tabs[`tab${i}`]));
            } else {
                component.tabs[`tab${i}`].map(component => {
                    if (this.validateIfShowOwnerAuthorized(component, holder)) {
                        items.push(this.doBuild(component, holder));
                    }
                });
            }
            let labelText = '';
            switch (holder.accountRelation) {
                case ACCOUNT_INTERVENTION_OWNER_CODE:
                    labelText = formatText('contractSummary-intevenierTitular');
                    break;
                case ACCOUNT_INTERVENTION_REPRESENTATIVE_CODE:
                    labelText = formatText('contractSummary-intevenierAttorney');
                    break;
                case ACCOUNT_INTERVENTION_AUTHORIZED_CODE:
                    labelText = formatText('contractSummary-intevenierAuthorized');
                    break;
            }
            tabs.push({
                label: labelText,
                content: (
                    <div>
                        {items}
                    </div>
                )
            });
            i++;
        });

        const openModal = tabsHolderValue ? tabsHolderValue.openModal : false;
        const requestClose = this.handleCloseHolderModal.bind(this, component);
        const removeHolder = this.handleRemoveHolder.bind(this, component);

        return (
            <div>
                <TabbedBox id="brokerIndexes" tabs={tabs} />
                <OKModal
                    description="contractsView-deleteHolderModalText"
                    footerType="navigation"
                    isOpen={openModal}
                    onCloseCallback={requestClose}
                    onPrimaryButtonClick={removeHolder}
                    onSecondaryButtonClick={requestClose}
                    primaryButtonText="contractsView-deleteHolderModalButtonDelete"
                    secondaryButtonText="contractsView-deleteHolderModalButtonBack"
                    title="contractsView-deleteHolderModalTitle"
                />
            </div>
        );
    }

    buildCountries = (countries) => {
        return countries.toJS().map(country => ({
            value: country.languageKey,
            label: country.name
        }))
    }

    handleShowFiocTest(event) {
        event.preventDefault();
        event.stopPropagation();

        let cardDetails = this.props.contractWizard.get('card_details');
        cardDetails = cardDetails.update(
            cardDetails.findIndex(component => component.get('id') === 'show_fioc'),
            component => component.set('value', true)
        );
        this.props.updateCardDetails(cardDetails);
    }

    buildWithoutFiocTest() {
        let contractNameTranslate = 'contractsView-fiocRequestCheckingAccount';

        if (this.props.current_contract.accountAlias === 'payroll_account') {
            contractNameTranslate = 'contractsView-fiocRequestPayrollAccount';
        }

        return (
            <div className="contract-view__fioc-message">
                <FormattedText value="contractsView-fiocRequestSubMessage1" />
                <OKLink
                    modifier="emphasize"
                    onClick={this.handleShowFiocTest}
                    to="/myprofile/purchase/payroll-account"                >
                    <FormattedText value="contractsView-fiocTestLink" />
                </OKLink>
                <FormattedText value="contractsView-fiocRequestSubMessage2" />
                <FormattedText value={contractNameTranslate} />
            </div>
        );
    }

    buildInfoBlock(isVisible) {
        let advertisingBlock = null;

        if (isVisible) {
            advertisingBlock = (
                <OKMessage
                    iconModifier="top"
                    type="informative"
                >
                    <FormattedText value="disclaimerPersonalInfo-NoAuthorizedOnAccountsMsg" />
                    &nbsp;
                </OKMessage>
            )
        }

        return advertisingBlock;
    }

    buildConfirmationLabel(labels, customCategoryEvent = undefined) {
        const labelElements = labels.map(item => {
            let element = <span key={item.get('text')}><FormattedText value={item.get('text')} /> </span>;
            let url;

            const href = item.get('href');
            url = hasTranslation(href) ? formatText(href) : href;

            if (url) {
                element = (
                    <OKLink
                        key={item.get('text')}
                        id={item.get('id')}
                        target="_blank"
                        to={url}
                        modifier="emphasize"
                        onClick={() => recordLink(customCategoryEvent ? customCategoryEvent : window.utag_last_name, LINK_CLICK_ACTION_EVENT, formatText(item.get('text')))}
                    >
                        {element}
                    </OKLink>
                );
            }

            return element;
        });

        return (
            <div className="contract-view__precontractual-confirmation">
                {labelElements}
            </div>
        );
    }

    buildParamsForHydratedContract = () => {
        const { contractWizard } = this.props;
        const {
            subType: hiringDataContract_subType,
            type: hiringDataContract_type,
        } = contractWizard.get('hiring_data_contract').toJS();

        return {
            tipoProducto: hiringDataContract_subType,
            subtipoProducto: hiringDataContract_type,
        };
    };

    hasValueIncomOrigin = () => {
        const { contractWizard } = this.props;
        const cardDetails = contractWizard.get('card_details') && contractWizard.get('card_details').toJS();
        return cardDetails[48] && cardDetails[48].disabled;
    }

    doBuild(component, holder = null) {
        const {
            closeModal,
            contractWizard,
            current_contract,
            getDocumentsOkApiById,
            hireAccountPassportOrFutureMode,
            immAccounts,
            immDeposits,
            immHireCardImageSelector,
            immHireCardPinSet,
            immFlagBasedFeatures,
            immProfileFields,
            isSetPinEnabled,
            localState,
            updateCardDetails,
            updateConfirmationCheckboxes,
            updateDepositProduct,
            tealiumEventCategory,
            termsAndCondsLegalWindowSetParams,
        } = this.props;
        const accountId = get(this.props, 'accountId', '');
        let source, element, values, errorsState;

        const cardDetails = contractWizard.get('card_details');
        const name_contract = contractWizard.get('name_contract')

        if (this.props.localState.loading){
            return <LoadingSection />
        }
        
        if (cardDetails && this.shouldBuildComponent(component)) {
            // If the component defined in the step has any services associated to it, they're called here.
            // It's important that they're declared below in the proptypes and the map dispatch to props.
            if (component.services) {
                component.services.forEach((service, index) => {
                    // If the service for the component wasn't called yet, we call it and set a flag to not call it again.
                    if (service.alreadyCalled) {
                        return
                    }

                    this.props[service.propName](isAContractThatNeedsHydration(name_contract) ? this.buildParamsForHydratedContract() : service.params);
                    component.services[index].alreadyCalled = true;
                }, this);
            }

            switch (component.id_component) {
                case 'tooltip':
                    return (
                        <div key={component.id_component} className={this.hasValueIncomOrigin() ? 'hide' : ''}>
                            <OKMessage type='informative'>
                                <FormattedText value={component.label} />
                                <FormattedText value={component.subLabel} />
                            </OKMessage>
                        </div>
                    );
                case 'disclaimer-personal-info':
                    const customTaggingCategory = component.customTaggingCategory ? contractBuilder[component.customTaggingCategory](contractWizard, immDeposits) : undefined;
                    return (
                        <ContractDisclaimerPersonalInfo
                            customTaggingCategory={customTaggingCategory}
                            cssModifier={component.cssModifier}
                            linkTextKey={component.linkTextKey}
                            linkUrlKey={component.linkUrlKey}
                            messageTitleKey={component.messageTitleKey}
                            messageKey={component.messageKey}
                            type={component.type}
                        />
                    );

                case 'fioc-profession-search':
                    return null;

                case 'fioc-profession':
                    const prefix = component.id.includes('holder_') ? component.id.substr(0, 9) : '';
                    const fiocProfessionError = formValidationHelper.getErrorMessage(
                        contractWizard.get('card_details'),
                        component
                    );
                    const fiocProfession = localState.card_details.filter(cardDetailsItem => cardDetailsItem.id === component.id)[0];
                    const value = fiocProfession ? fiocProfession.value : component.default_value;

                    return (
                        <FiocProfession
                            component={component}
                            contractWizard={contractWizard}
                            handleOnChange={this.handleChange.bind(this, component)}
                            prefix={prefix}
                            professionError={fiocProfessionError}
                            value={value}
                            updateCardDetails={updateCardDetails}
                        />
                    );
                case 'section-header':
                    return (
                        <div>
                            {this.buildSectionHeader(component)}
                        </div>
                    );

                case 'without-joinholders':
                    return (
                        <div className="contract-view__without-joinholders">
                            <div className="contract-view__without-joinholders__image" />
                            <p className="contract-view__without-joinholders__text">
                                <FormattedText value={component.text} />
                            </p>
                        </div>
                    );

                case 'custom-text':
                    return (
                        <div className="custom-text">
                            <FormattedText value={component.text} />
                        </div>
                    );

                case 'label':
                    const okLabel = (
                        <div>
                            <FormattedText value={component.label} />
                        </div>
                    );
                    const okSubLabel =
                        component.subLabel &&
                        <FormattedText value={component.subLabel} className="ok-input__label" />;

                    return (
                        <label className="contract-view__dropdown-label">
                            {okLabel}
                            {okSubLabel}
                        </label>
                    );

                case 'special-label':
                    let label = formatText(component.label);
                    return (
                        <label className="special-label">
                            {label}
                        </label>
                    );

                case 'section-sub-header':
                    return (
                        <div>
                            {this.buildSectionSubHeader(component)}
                        </div>
                    );

                case 'simple-text':
                    const simpleTextClassName = classNames('contract-view__simple-text', {
                        [component.extraClass]: component.extraClass
                    });
                    return (
                        <div className={simpleTextClassName}>
                            <FormattedText value={component.label} />
                        </div>
                    );

                case 'label-deposit': {
                    const refreshFunction = component.refreshFunction ? this.props[component.refreshFunction] : null;
                    return (
                        <ContractLabelDeposit
                            immProfile={immProfileFields}
                            immContract={contractWizard}
                            localState={localState}
                            immDeposits={immDeposits}
                            actions={{updateCardDetails, updateDepositProduct, updateConfirmationCheckboxes, refreshFunction, termsAndCondsLegalWindowSetParams}}
                        />
                    );
                }

                case 'deposit-renewal-import-input':
                    {
                        let importAmountInputSection = <LoadingSection />;
                        const isDepositExpired = name_contract === CONTRACT_INDEX_DEPOSIT_EXPIRATION
                        if (component.source && typeof component.source === 'string') {
                            component = contractBuilder[component.source](contractWizard, component);
                        }
                        const amountToTransfer = localState.card_details.find((element) => element.id === 'monto_traspasar').value

                        if (component.importMax && (amountToTransfer !== null || isDepositExpired)) {
                            
                            let balance = component.importMax;
                            component.errorMessageAmount = formatInterest(component.importMax, false)
                            if (isDepositExpired) {
                                const accountBalance = localState.card_details.find((element) => element.id === 'balance_account').value;
                                if (balance > accountBalance) {
                                    balance = accountBalance;
                                    component.errorMessage = component.accountErrorMessage;
                                }
                            }
                            component.importMax = null;
                            const inputProps = {
                                component,
                                amountToTransfer: amountToTransfer,
                                maxValueToHire: null,
                                ...(component.extraValueValidation && { balance }),
                            }
                            importAmountInputSection = this.buildImportAmountInput(...Object.values(inputProps));
                        }
                        return importAmountInputSection;
                    }
                case 'import-amount-input':
                    let importAmountInputSection = <LoadingSection />;
                    if (component.source && typeof component.source === 'string') {
                        component = contractBuilder[component.source](contractWizard, component);
                    }
                    if (component.importMin) {
                        const amountToTransfer = localState.card_details.find((element) => element.id === 'monto_traspasar').value;
                        const depositHireData = contractWizard.get('depositHireData');
                        const maxValueToHire = `${formatAmount(depositHireData.get('bssaldo1'))} ${EURO_SYMBOL}`;
                        const balance = localState.card_details.find((element) => element.id === 'balance_account').value;
                        const inputProps = {
                            component,
                            amountToTransfer,
                            maxValueToHire,
                            ...(component.extraValueValidation && { balance }),
                        }
                        importAmountInputSection = this.buildImportAmountInput(...Object.values(inputProps));
                    }
                    return importAmountInputSection;

                case 'slider':
                    const sliderExtraInfo = component.buildExtraInfo
                        ? contractBuilder[component.buildExtraInfo](contractWizard)
                        : null;
                    let sliderSection = <LoadingSection />;

                    if (component.source && typeof component.source === 'string') {
                        component = contractBuilder[component.source](contractWizard, component);
                    }

                    if (contractWizard.get('limitCreditMarks') || !component.services) {
                        sliderSection = (
                            <ContractSlider
                                localState={localState}
                                contractWizard={contractWizard}
                                component={component}
                                updateCardDetails={updateCardDetails}
                                handleOnChange={this.onAfterChange}
                                extraInfo={sliderExtraInfo}
                            />
                        );
                    }

                    return sliderSection;

                case 'combo':
                    return (
                        <div>
                            {this.buildCombo(component)}
                        </div>
                    );


                case 'dropdown-deposits':
                    const refreshFunction = component.refreshFunction ? this.props[component.refreshFunction] : null;
                    return (
                        <ContractDropdownDeposit
                            localState={localState}
                            immContract={contractWizard}
                            component={component}
                            actions={{updateCardDetails, updateDepositProduct, updateConfirmationCheckboxes, refreshFunction, termsAndCondsLegalWindowSetParams}}
                            contractBuilder={contractBuilder}
                            originCountry={immProfileFields.get('originCountry')}
                        />
                    );

                case 'dropdown-accounts':
                    const {
                        immCards,
                        isInactiveAccountsEnabled,
                        setIntervenerType,
                        addIntervener,
                        removeIntervener,
                        restoreDefaultInterveners,
                        requestInterveners,
                        requestIntervenersSpecial,
                        requestAccountsSpecial,
                        changeIntervenerRelationship,
                        excludeIntervener,
                        setAccount,
                        setAllAccountsToInactive,
                    } = this.props;
                    const actions = {
                        updateCardDetails,
                        setIntervenerType,
                        addIntervener,
                        removeIntervener,
                        restoreDefaultInterveners,
                        requestInterveners,
                        requestIntervenersSpecial,
                        requestAccountsSpecial,
                        changeIntervenerRelationship,
                        excludeIntervener,
                        setAccount
                    };

                    const customCategoryEvent = component.customCategoryEvent ? contractBuilder[component.customCategoryEvent](contractWizard) : undefined;
                    const contractDropdownAccountAccountChangeExtraFn = component.accountChangeExtraFn
                        ? this.props[component.accountChangeExtraFn]
                        : null;
                    const showSavingsAccountsMessage = component.showSavingsAccountsMessage ? component.showSavingsAccountsMessage : false;
                    const depositId = contractWizard.get('renewalOrExpiredDepositId');
                    let accId;
                    if (depositId) {
                        const cardDetailsAccValue = contractWizard.get('card_details').find(x => x.get('id') === 'cta_seleccionada').get('value');
                        const deposit = immDeposits.getIn(['byId', depositId]);
                        const renewalAccount = immAccounts.get('byId').filter(account =>
                            (account.get('contractNumber') === deposit.getIn(['impositionAssociatedAccount', 'contractNumber']) &&
                            account.get('product') === deposit.getIn(['impositionAssociatedAccount', 'product'])))
                        const immAccount = immAccounts.getIn(['byId', renewalAccount.first().get('accountId'), 'accountId']);
                        accId = contractWizard.get('name_contract') === 'depositrenewal' && (cardDetailsAccValue || immAccount)
                    }
                    return (
                        <ContractDropdownAccount
                            accountId={accountId || accId}
                            doTagging={!depositId}
                            localState={localState}
                            immContract={contractWizard}
                            immAccounts={immAccounts}
                            immCards={immCards}
                            flagBasedFeatures={immFlagBasedFeatures}
                            isInactiveAccountsEnabled={isInactiveAccountsEnabled}
                            component={component}
                            actions={actions}
                            showDisclaimer={component.showDisclaimer}
                            contractBuilder={contractBuilder}
                            accountChangeExtraFn={contractDropdownAccountAccountChangeExtraFn}
                            intervenersHeader={component.intervenersHeader}
                            showIntervenersOnlyInCard={component.showIntervenersOnlyInCard}
                            onlyUpgradeableToPayroll={current_contract.onlyUpgradeableToPayroll}
                            currencyAllowed={component.currencyAllowed}
                            setAllAccountsToInactive={setAllAccountsToInactive}
                            showSavingsAccountsMessage={showSavingsAccountsMessage}
                            customCategoryEvent={customCategoryEvent}
                        />
                    );

                case 'loading-section':
                    return <LoadingSection />;

                case 'radio-button':
                    return (
                        <div>
                            {this.buildRadioButtonGroup(component)}
                        </div>
                    );

                case 'step1-deposit-transfer':
                    return (
                        <Step1DepositTransfer
                            getDocumentsOkApiById={getDocumentsOkApiById}
                            showBlockedAccountMessage={component.showBlockedAccountMessage}
                            immAccounts={immAccounts}
                            immContract={contractWizard}
                            immDeposits={immDeposits}
                            immProfileFields={this.props.immProfileFields}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                        />)

                case 'step1-contract-savings':
                    const { match } = this.props
                    const { params: { redirect: productId } } = match
                    const mainAccount = contractWizard.get('mainAccount')
                    return (
                        <Step1ContractSavings
                            getDocumentsOkApiById={getDocumentsOkApiById}
                            showBlockedAccountMessage={component.showBlockedAccountMessage}
                            immAccounts={immAccounts}
                            immContract={contractWizard}
                            immDeposits={immDeposits}
                            localState={localState}
                            updateCardDetails={updateCardDetails}
                            updateConfirmationCheckboxes={updateConfirmationCheckboxes}
                            immProfileFields={this.props.immProfileFields}
                            immFlagBasedFeatures={immFlagBasedFeatures}
                            productId={productId}
                            getPrecontractualDocumentURLOrID={this.props.getPrecontractualDocumentURLOrID}
                            mainAccount={mainAccount}
                        />)

                case 'contract-info':
                    const { gestorCrossEnabled, flagBasedFeatures } = this.props;
                    let productInformationComponent;
                    if (gestorCrossEnabled && flagBasedFeatures.get(GC)) {
                        productInformationComponent = (
                            <HiringProductInformation
                                productAlias={current_contract.accountAlias}
                                productComponentId={PRODUCT_HIRING_COMPONENT_ID}
                                productType={PRODUCT_TYPE_ACCOUNT}
                            />
                        )
                    } else {
                        const { getContractInformation, getContractInformationWithPricing } = this.props;
                        productInformationComponent = (
                            <ContractInformation
                                component={component}
                                contractWizard={contractWizard}
                                getContractInformation={getContractInformation}
                                getContractInformationWithPricing={getContractInformationWithPricing}
                                immProfile={this.props.immProfileFields}
                            />
                        )
                    }

                    return productInformationComponent;

                case 'legal-information':
                    const LegalConfirmation = !!__CONTACT_CENTER__ && this.buildLegalConfirmation(component, contractBuilder);
                    return LegalConfirmation;

                case 'step2-dic-viewer':
                    const { setAcceptDocument, getPreContractualDocumentationList, immPrecontractualDocumentation, preContractualPollingInitialization, precontractualAlias } = this.props
                    const documentList = immPrecontractualDocumentation.getIn(['documentation', 'documents']);
                    const isLoadingDocumentList = immPrecontractualDocumentation.getIn(['documentation', 'isFetching']);
                    const aDocumentWasAccepted = immPrecontractualDocumentation.getIn(['documentation', 'acceptedDocument']);
                    const isLoadingPDF = immPrecontractualDocumentation.getIn(['documentation', 'isPdfFetching']);
                    const isLoadingDocuments = immPrecontractualDocumentation.getIn(['documents', 'isFetching']);
                    const precontractualHasBeenInit = immPrecontractualDocumentation.getIn(['documents', 'success'])
                    const aDocumentWasNotAccepted = immPrecontractualDocumentation.getIn(['documentation', 'acceptingDocumentFailed'])

                    const precontractualLabel = this.buildConfirmationLabel(contractWizard.get('precontractualConfirmationLabel'), customCategoryEvent)

                    const precontractualDocumentId = contractWizard.get('precontractualDocumentId');
                    const precontractualDocumentUrl = contractWizard.get('precontractualDocumentUrl');

                    const accountDicDocumentUrl = contractWizard.getIn(['mainAccount', 'data','accountConfig', 'precontractualDicUrl'], null);

                    const handleUpdateConfirmationCheckboxes = () => {
                        const list = contractWizard.getIn(['confirmationCheckboxes', 'list'])
                        if (__CONTACT_CENTER__) {
                            const updatedList = list.map(item => item.set('value', true))
                            updateConfirmationCheckboxes({
                                areValid: true,
                                list: updatedList,
                            });
                        } else {
                            updateConfirmationCheckboxes({
                                areValid: true,
                                list,
                            });
                        }
                    }

                    return (
                        <DocumentationViewer
                            precontractualAlias={precontractualAlias}
                            documentList={documentList}
                            precontractualHasBeenInit={precontractualHasBeenInit}
                            isLoadingDocuments={isLoadingDocuments || isLoadingPDF}
                            isLoadingDocumentList={isLoadingDocumentList}
                            getPreContractualDocumentationList={getPreContractualDocumentationList}
                            preContractualPollingInitialization={preContractualPollingInitialization}
                            onSavedocumentAcceptance={setAcceptDocument}
                            aDocumentWasAccepted={aDocumentWasAccepted}
                            aDocumentWasNotAccepted={aDocumentWasNotAccepted}
                            precontractualLabel={precontractualLabel}
                            precontractualDocumentId={precontractualDocumentId}
                            precontractualDocumentUrl={precontractualDocumentUrl}
                            precontractualDicUrl={accountDicDocumentUrl}
                            onAcceptAllDocument={handleUpdateConfirmationCheckboxes}
                        />
                    )

                case 'precontractual-conditions':
                    const isDeposit = [CONTRACT_INDEX_DEPOSIT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_WITHOUT_NEW_MONEY, CONTRACT_INDEX_DEPOSIT_TRANSFER, CONTRACT_INDEX_DEPOSIT_RENEWAL].includes(contractWizard.get('name_contract'));
                    const isOffice = __CONTACT_CENTER__ && isPrintOfficeMode();
                    if (!isDeposit || !__CONTACT_CENTER__ || isOffice) {
                        const customCategoryEvent = component.customCategoryEvent ? contractBuilder[component.customCategoryEvent](contractWizard) : undefined;
                        const preContractConditionsDocument = localState.preContractConditionsDocuments;
                        const pdfViewer = preContractConditionsDocument ? (
                            <div className="contract-confirmation-step__pdf-section">
                                <PreContractualDocumentViewer
                                    customCategoryEvent={customCategoryEvent}
                                    displayScrollButton={true}
                                    preContractDocumentInfo={preContractConditionsDocument}
                                    titleKey={'preContractDocument_precontractualConditionsPdfTitle'}
                                    hasPolling={current_contract.hasPolling}
                                    viewerHeight={762}
                                />
                                {(!isDeposit || !isOffice) && contractWizard.get('conditionDocumentConfirmation') && this.buildConfirmationLabel(contractWizard.get('precontractualConfirmationLabel'), customCategoryEvent)}
                            </div>)
                            :
                            (
                                <EmptyState
                                    primaryText={formatText('contractConfirmation-pdfError')}
                                    iconType="noitems-banking"
                                />
                            );
                        return pdfViewer;
                    } else {
                        return null;
                    }

                case 'account-holder-info':
                    const infoBlock = !!__CONTACT_CENTER__ && this.buildInfoBlock(component.is_visible);
                    return infoBlock;

                case 'amount-input':
                    return (
                        <div>
                            {this.buildAmountInput(component)}
                        </div>
                    );

                case 'tax-additional-country':
                    let addingFlag = true;
                    let disableAdd = false;
                    let disableEdit = false;
                    let disableRemove = false;
                    const { tinLength, tinRegex } = component;
                    const targetValue = Immutable.fromJS(
                        formHelper.getFieldInTarget(
                            Immutable.fromJS(localState.card_details),
                            component.id
                        )
                    );
                    const immCountries = targetValue.size > 0 ? targetValue.get('value') : Immutable.List();

                    if (contractWizard.get('name_contract') === 'junior-account') {
                        const disabled = contractWizard.get('card_details').find(item => item.get('id') === component.id).get('disabled');
                        addingFlag = !disabled;
                        disableAdd = disabled;
                        disableEdit = disabled;
                        disableRemove = disabled;
                    }

                    return (
                        <TaxAdditionalCountryForm
                            AddingFlag={addingFlag}
                            disableAdd={disableAdd}
                            disableEdit={disableEdit}
                            disableRemove={disableRemove}
                            immCountries={immCountries}
                            onDeleteCountry={this.handleDeleteTaxCountry}
                            onSaveCountry={this.handleAddTaxCountry}
                            tinLength={tinLength}
                            tinRegex={tinRegex}
                        />
                    );

                case 'fioc':
                    return (
                        <Fioc
                            buildComponent={this.doBuild.bind(this)}
                            component={component}
                        />
                    );

                case 'fioc-is-updated':
                    return (
                        <div key={component.id_component}>
                            {this.buildWithoutFiocTest()}
                        </div>
                    );

                case 'custom-error-message':
                    const errorMessage = component.msg_error && formatText(component.msg_error);

                    let errorState = false;
                    if (contractWizard.get('card_details')) {
                        errorState = true;
                        component.chekcIds.map(id => {
                            const element = contractWizard
                                .get('card_details')
                                .find(cardDetail => cardDetail.get('id') === id);
                            const isErrorVisible = element && element.get('isErrorVisible');
                            errorState = isErrorVisible && errorState;
                        });
                    }
                    const errorClass = classNames({
                        [component.classNames]: errorState
                    });
                    errorState && component?.chekcIds?.[0] && customCheckboxErrorFiocTagging(component.chekcIds[0], errorMessage);

                    return (
                        <div className={errorClass}>
                            <CustomErrorMessage
                                type={component.type}
                                errorState={errorState}
                                errorMessage={errorMessage}
                            />
                        </div>
                    );

                case 'tabbed-box':
                    return (
                        <div>
                            {this.buildTabs(component)}
                        </div>
                    );

                case 'tabs-holder':
                    return (
                        <div>
                            {this.buildTabsHolder(component)}
                        </div>
                    );

                case 'input-safe':
                    let disabled;
                    let onHandleValidateChange;
                    if (contractWizard.get('name_contract') === 'junior-account') {
                        disabled = contractWizard.get('card_details').find(item => item.get('id') === component.id).get('disabled');
                    }

                    if (!!component.onChangeRoadNameFn) {
                        onHandleValidateChange = contractBuilder[component.onChangeRoadNameFn];
                    }

                    return (
                        <ContractInput
                            component={component}
                            disabled={disabled}
                            immCardDetails={contractWizard.get('card_details')}
                            onHandleBlur={this.handleBlur.bind(this, component)}
                            onHandleValidateChange={onHandleValidateChange}
                        />
                    );

                case 'input-iban':
                    return (
                        <div>
                            {this.buildInputIban(component)}
                        </div>
                    );

                case 'full_name':
                    return (
                        <div>
                            {this.buildFullName(component)}
                        </div>
                    );

                case 'phone-line':
                    return (
                        <div>
                            {this.buildPhoneLine(component)}
                        </div>
                    );

                case 'date-picker':
                    return (
                        <div>
                            {this.buildDateTimePicker(component)}
                        </div>
                    );

                case 'informative-list':
                    return (
                        <div>
                            {this.buildInformativeList(component)}
                        </div>
                    );

                case 'checkbox':
                    return (
                        <div className="contract-view__checkbox">
                            {this.buildCheckbox(component)}
                        </div>
                    );

                case 'condition-show':
                    let conditionShow = false;
                    let conditionValue1 = '';
                    let conditionValue2 = '';
                    switch (component.conditionType) {
                        case 'array-pos':
                            conditionValue1 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId1
                            ).value;
                            conditionShow =
                                conditionValue1[component.conditionPos] ==
                                component.conditionValue1;
                            break;
                        case 'single':
                            conditionValue1 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId1
                            ).value;
                            conditionShow = conditionValue1 == component.conditionValue1;
                            break;
                        case 'and':
                            conditionValue1 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId1
                            ).value;
                            conditionValue2 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId2
                            ).value;
                            conditionShow =
                                conditionValue1 == component.conditionValue1 &&
                                conditionValue2 == component.conditionValue2;
                            break;
                        case 'or':
                            conditionValue1 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId1
                            ).value;
                            conditionValue2 = localState.card_details.find(
                                cardDetailsItem => cardDetailsItem.id === component.conditionId2
                            ).value;
                            conditionShow =
                                conditionValue1 == component.conditionValue1 ||
                                conditionValue2 == component.conditionValue2;
                            break;
                        case 'ifPrevIsComplete':
                            if (component.conditionIds) {
                                let count = 0;
                                component.conditionIds.map(value => {
                                    if (
                                        localState.card_details.find(
                                            cardDetailsItem => cardDetailsItem.id === value
                                        ).value
                                    ) {
                                        count++;
                                    }
                                });
                                if (count) conditionShow = true;
                            } else if (component.conditionId1WithOr) {
                                let count = 0;
                                component.conditionId1WithOr.forEach(id => {
                                    if (localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === id
                                    ).value) {
                                        count++;
                                    }
                                });
                                conditionShow = !!count;
                            } else {
                                const value = localState.card_details.find(
                                    cardDetailsItem => cardDetailsItem.id === component.conditionId1
                                ).value;
                                if (value === -1) {
                                    conditionShow = false;
                                } else {
                                    conditionShow = value !== null && value !== '';
                                }
                            }
                    }

                    let returnItems = null;
                    if (conditionShow) {
                        let items = [];
                        if (!Array.isArray(component.item)) {
                            items.push(this.doBuild(component.item));
                        } else {
                            component.item.map(component => {
                                items.push(this.doBuild(component));
                            });
                        }
                        returnItems = (
                            <div className="contract-view__condition">
                                {items}
                            </div>
                        );
                    }

                    return returnItems;

                case 'profession-cnae':
                    const { extraClasses } = component;
                    const className = classNames(extraClasses);
                    return (
                        <div className={className}>
                            {this.buildProfessionCnae(component)}
                        </div>
                    );

                case 'profession-current':
                    return (
                        <div>
                            {this.buildProfessionCurrent(component)}
                        </div>
                    )

                case 'profession-cno':
                    return (
                        <div>
                            {this.buildProfessionCno(component)}
                        </div>
                    );

                case 'tax-data':
                    source = contractBuilder[component.source]();
                    return (
                        <div>
                            <TaxData
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                dataReceiver={this.onHandleTaxDataReceiver}
                                radioOptions={source}
                                type={component.type}
                            />
                        </div>
                    );

                case 'political-charge':
                    source = contractBuilder[component.source]();
                    return (
                        <div>
                            <PoliticalCharge
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                type={component.type}
                                politicalChargeOptions={source}
                                withOption={source[0].value}
                                dataReceiver={this.onHandlePoliticalChargeReceiver}
                            />
                        </div>
                    );

                case 'own-money-select':
                    source = contractBuilder[component.source]();
                    return (
                        <div>
                            <OwnMoneySelect
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                type={component.type}
                                radioOptions={source}
                                dataReceiver={this.onHandleOwnMoneyReceiver}
                            />
                        </div>
                    );

                case 'foreign-tax':
                    const imtSource = contractBuilder[component.imtSource]();
                    const maxTributationCountries = current_contract.maxTributationCountries || undefined;
                    source = contractBuilder[component.source]();
                    element = localState.card_details.find(
                        cardDetailsItem => cardDetailsItem.id === component.id
                    );
                    values = element.value ? element.value : [];

                    errorsState = [false, []];
                    if (contractWizard.get('card_details')) {
                        errorsState = contractWizard
                            .get('card_details')
                            .filter(cardDetailsItem => cardDetailsItem.get('id') === component.id)
                            .get(0)
                            ? contractWizard
                                .get('card_details')
                                .find(
                                    cardDetailsItem => cardDetailsItem.get('id') === component.id
                                )
                                .get('isErrorVisible')
                            : [false, []];

                        if (!errorsState) {
                            errorsState = [false, []];
                        }
                    }
                    return (
                        <div>
                            <ForeignTax
                                values={values}
                                radioOptions={source}
                                taxCountryOptions={this.buildCountries(contractWizard.get('countries'))}
                                imtOptions={imtSource}
                                errorsState={errorsState}
                                id={component.id}
                                dataReceiver={this.onHandleForeignTaxReceiver.bind(this, component)}
                                maxTributationCountries={maxTributationCountries}
                                disableFinishButton={this.props.disableFinishButton}
                                handleOnFocus={this.handleOnFocus}
                                handleOnBlur={fiocFiscalCountryCloseTagging}
                            />
                        </div>
                    );

                case 'holders':
                    const { addSimpleIntervener, clearInterveners } = this.props;
                    const {
                        holderDescription,
                        id: holderId,
                        identificationTypeSource,
                        regexInputFullName,
                        relationTypeSource,
                        source: holderSource
                    } = component;
                    const immCardDetails = contractWizard.get('card_details');
                    const componentIdentificationTypeSource = contractBuilder[
                        identificationTypeSource
                        ]();
                    const componentRelationTypeSource = contractBuilder[relationTypeSource]();
                    const componentSource = contractBuilder[holderSource]();
                    let immPersonalInfoDisclaimerComponent;

                    element = localState.card_details.find(
                        cardDetailsItem => cardDetailsItem.id === holderId
                    );
                    values = element.value || [];
                    errorsState = [false, []];
                    if (immCardDetails) {
                        immPersonalInfoDisclaimerComponent = findElementbyId(immCardDetails, 'holders-personal-info-disclaimer', undefined, false);
                        errorsState = findElementbyId(
                            immCardDetails,
                            holderId,
                            'isErrorVisible'
                        ) || [false, []];
                    }
                    return (
                        <div>
                            <Holders
                                values={values}
                                radioOptions={componentSource}
                                relationTypeSource={componentRelationTypeSource}
                                identificationTypeSource={componentIdentificationTypeSource}
                                errorsState={errorsState}
                                holderDescription={holderDescription}
                                regexInputFullName={regexInputFullName}
                                dataReceiver={this.onHandleHoldersReceiver.bind(this, component)}
                                interveners={findElementbyId(immCardDetails, 'holders')}
                                addSimpleIntervener={addSimpleIntervener}
                                clearInterveners={clearInterveners}
                                immProfileFields={immProfileFields}
                                onPersonalInfoDisclaimerCheck={this.handlePersonalInfoDisclaimerCheck}
                                immPersonalInfoDisclaimerComponent={immPersonalInfoDisclaimerComponent}
                                immPersonalInfoDisclaimerTexts={Immutable.fromJS(component.personalInfoDisclaimerTexts)}
                            />
                        </div>
                    );

                case 'laboral-data':
                    return (
                        <div>
                            <LaboralData
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                dataReceiver={this.onHandleLaboralDataReceiver}
                            />
                        </div>
                    );

                case 'add-holder':
                    return (
                        <div className="laboral-data__component-padding-bottom">
                            <AddHolder
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                dataReceiver={this.onHandleAddHolderDataReceiver}
                            />
                        </div>
                    );

                case 'add-promotional-code':
                    return (
                        <div>
                            <AddPromotionalCode
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                dataReceiver={this.onHandleAddPromotionalCodeDataReceiver}
                            />
                        </div>
                    );

                case 'method-of-payment':
                    //Set the default value for methodOfPayment
                    if (!__CONTACT_CENTER__)
                        return null
                    const { card_details } = localState;
                    const methodOfPayment = card_details.find(
                        cardDetailsItem => cardDetailsItem.id === 'methodOfPayment'
                    ).value;
                    const extraInfo =
                        component.buildExtraInfo &&
                        contractBuilder[component.buildExtraInfo](contractWizard);
                    const error = formValidationHelper.getErrorMessage(card_details, component);
                    const creditLimit = findElementbyId(
                        contractWizard.get('card_details'),
                        component.creditLimitTarget
                    );
                    return (
                        <MethodOfPayment
                            nameContract={contractWizard.get('name_contract')}
                            title={component.title}
                            percentageOptions={contractBuilder[component.percentageOptions]()}
                            percentageDefaultOption={component.percentageDefaultOption}
                            fixedOptions={contractBuilder[component.fixedFeeOptions](creditLimit, contractWizard.get('name_contract'))}
                            fixedFeeDefaultOption={component.fixedFeeDefaultOption}
                            immCardDetails={contractWizard.get('card_details')}
                            values={methodOfPayment}
                            dataReceiver={this.onHandleMethodOfPaymentDataReceiver.bind(
                                this,
                                component
                            )}
                            extraInfo={extraInfo}
                            errorMessage={error.message}
                            errorState={error.state}
                        />
                    );

                case 'credit-limit-selection':
                    const cardDetails = contractWizard.get('card_details');
                    if (cardDetails) {
                        const requestedAmount = findElementbyId(cardDetails, 'creditLimit');
                        const methodOfPayment =
                            findElementbyId(cardDetails, 'methodOfPayment') || '';
                        const maxLimitToAuthorize = contractWizard.get('maxLimitToAuthorize') || '';
                        const disableContinue =
                            component.disableContinue &&
                            contractBuilder[component.disableContinue](
                                maxLimitToAuthorize,
                                methodOfPayment
                            );
                        const bindCloseModal = closeModal.bind(this, component.id);
                        source = contractBuilder[component.source](
                            requestedAmount,
                            maxLimitToAuthorize,
                            disableContinue
                        );
                        return (
                            <CreditLimitSelection
                                creditOptions={source}
                                disableContinue={disableContinue}
                                handleOnRequestContinue={this.props.nextStep}
                                handleOnRequestClose={bindCloseModal}
                                openModal={contractWizard
                                    .get('card_details')
                                    .find(x => x.get('id') === component.id)
                                    .get('openModal')}
                                dataReceiver={this.onHandleCreditLimitSelectionDataReceiver}
                                localState={this.state}
                                contractWizard={contractWizard}
                                component={component}
                                updateCardDetails={updateCardDetails}
                            />
                        );
                    }
                    break;

                case 'investment-fund-list':
                    return (
                        <div>
                            <InvestmentFundList
                                values={
                                    localState.card_details.find(
                                        cardDetailsItem => cardDetailsItem.id === component.id
                                    ).value
                                }
                                dataReceiver={this.onHandleInvestmentListDataReceiver}
                            />
                        </div>
                    );

                case 'validation-modal':
                    const {
                        allowContinue,
                        cancelRoute,
                        content,
                        customCloseButton,
                        id,
                        initialLoad,
                        open,
                        showCloseButton,
                        title,
                        titleType,
                        primaryButtonText,
                        primaryButtonTextAllowContinue,
                        onMoldalStateChange
                    } = component;
                    const validationModalShouldOpen = open && contractBuilder[open];
                    const validationModalContent = contractBuilder[content](contractWizard);
                    const validationModalAllowContinue =
                        typeof allowContinue === 'string'
                            ? contractBuilder[allowContinue]
                            : allowContinue;
                    const onRequestClose = initialLoad
                        ? this.handleCancel
                        : closeModal.bind(this, component.id);
                    const titleKey =
                        titleType === 'calculated' ? contractBuilder[title](contractWizard) : title;
                    const validationModalTitle = formatText(titleKey);
                    const leaveButtonText =
                        component.leaveButtonText || 'contractsView-validationModalLeaveMessage';
                    const closeButton = customCloseButton ? contractBuilder[customCloseButton]() : null;
                    let validationModalopenModal;

                    if (!validationModalShouldOpen || !initialLoad) {
                        validationModalopenModal = findElementbyId(
                            contractWizard.get('card_details'),
                            id,
                            'openModal'
                        );
                    }
                    const modalId = findElementbyId(
                        contractWizard.get('card_details'),
                        id,
                        'openModal'
                    )
                    if (modalId) {
                        onMoldalStateChange && contractBuilder[onMoldalStateChange](contractWizard, 'OPEN')
                    }
                    const onValidationModalClose = () => {
                        onMoldalStateChange && contractBuilder[onMoldalStateChange](contractWizard, 'CLOSED')
                    }
                    const onValidationContinue = () => {
                        onMoldalStateChange && contractBuilder[onMoldalStateChange](contractWizard, 'ONCONTINUE')
                    }
                    const onValidationBack = () => {
                        onMoldalStateChange && contractBuilder[onMoldalStateChange](contractWizard, 'ONBACK')
                    }

                    return (
                        <ValidationModal
                            onContinue={onValidationContinue}
                            onClosed={onValidationModalClose}
                            onBack={onValidationBack}
                            handleOnRequestContinue={this.props.nextStep}
                            handleOnRequestClose={onRequestClose}
                            openModal={validationModalopenModal}
                            title={validationModalTitle}
                            allowContinue={validationModalAllowContinue}
                            shouldOpen={validationModalShouldOpen}
                            cancelRoute={cancelRoute}
                            customCloseButton={closeButton}
                            initialLoad={initialLoad}
                            showCloseButton={showCloseButton}
                            contractWizard={contractWizard}
                            leaveButtonText={leaveButtonText}
                            primaryButtonText={primaryButtonText}
                            primaryButtonTextAllowContinue={primaryButtonTextAllowContinue}
                        >
                            {validationModalContent}
                        </ValidationModal>
                    );

                case 'information-modal':
                    const modalInfoTitle = component.title && formatText(component.title);
                    const modalInfoContent = component.contentType && component.contentType === 'complex' ? contractBuilder[component.content](contractWizard)
                        : formatText(component.content)
                    const modalInfoAction = component.action && contractBuilder[component.action];
                    const modalInfoOpen =
                        findElementbyId(
                            contractWizard.get('card_details'),
                            component.id,
                            'openModal'
                        ) || component.openModal;

                    if (modalInfoOpen) {
                        component.onMoldalStateChange && contractBuilder[component.onMoldalStateChange](contractWizard, 'OPEN')
                    }
                    const onInformationModalClose = () => {
                        component.onMoldalStateChange && contractBuilder[component.onMoldalStateChange](contractWizard, 'CLOSED')
                    }
                    const onInformationContinue = () => {
                        component.onMoldalStateChange && contractBuilder[component.onMoldalStateChange](contractWizard, 'ONCONTINUE')
                    }

                    return (
                        <InformationModal
                            onContinue={onInformationContinue}
                            onClosed={onInformationModalClose}
                            title={modalInfoTitle}
                            component={component}
                            handleAction={modalInfoAction}
                            contractWizard={localState.card_details}
                            updateCardDetails={updateCardDetails}
                            content={modalInfoContent}
                            openModal={modalInfoOpen}
                        />
                    );

                case 'ok-button':
                    return this.buildOKButton(component);

                case 'tab-form':
                    const isVisible = !localState.card_details
                        .find(cardDetailsItem => cardDetailsItem.id === 'excludes_id')
                        .value.includes(component.id);

                    let toReturn = null;
                    if (this.validateIfShowOwnerAuthorized(component, holder)) {
                        toReturn = (
                            <ContractAccordion
                                buildComponent={this.doBuild.bind(this)}
                                isVisible={isVisible}
                                component={component}
                            />
                        );
                    }

                    return toReturn;

                case 'grid-form':
                    const isGridFormVisible = !localState.card_details
                        .find(cardDetailsItem => cardDetailsItem.id === 'excludes_id')
                        .value.includes(component.id);

                    let gridContent;
                    if (this.validateIfShowOwnerAuthorized(component, holder)) {
                        gridContent = (
                            <GridForm
                                buildComponent={this.doBuild.bind(this)}
                                isVisible={isGridFormVisible}
                                component={component}
                            />
                        );
                    }

                    return gridContent;

                case 'card-image-selector':
                    const originCountry = immProfileFields.get('originCountry');
                    const maestroCard = immFlagBasedFeatures.get(NEW_PLASTIC_MAESTRO);
                    let cardImageIds = maestroCard ? component.cardImageIdsFF : component.cardImageIds;
                    let cardImageSelectorCustomTitle;
                    if (hireAccountPassportOrFutureMode) {
                        if (originCountry === DEFAULT_COUNTRY) {
                            cardImageIds = maestroCard ? component.cardImageIdsFF : component.cardImageIds;
                        } else {
                            let cardImageIdsProp = maestroCard ? 'cardImageIdsFF' : 'cardImageIds';

                            if (localState.card_details.find(item => item.id === 'card_image').value === '') {
                                let defaultCardProp = 'value';

                                if (contractWizard.get('name_contract') === 'checking-account' && immFlagBasedFeatures.get(R42_TRAVEL_PLUS_OFF_HIRING)) {
                                    defaultCardProp = 'valueStandardOff';
                                    cardImageIdsProp = maestroCard ? 'cardImageIdsStandardOffFF':'cardImageIdsStandardOff';
                                }

                                const defaultCardImage = localState.card_details.find(
                                    cardDetailsItem => cardDetailsItem.id === 'card_image_no_es'
                                )[defaultCardProp][originCountry];

                                let modCardDetails = localState.card_details;

                                modCardDetails.find(item => item.id === 'card_image').value = defaultCardImage;
                                updateCardDetails(modCardDetails);
                            }

                            cardImageIds = component[cardImageIdsProp][originCountry];
                        }
                    }

                    if (['checking-account', 'payroll-account'].includes(contractWizard.get('name_contract')) &&
                        immHireCardImageSelector.get('imagesById').size > 1) {
                        cardImageSelectorCustomTitle = 'hireCardImageSelector-hireCardImageSelector_debitCard';
                    }

                    return (
                        <HireCardImageSelector
                            cardImageIds={cardImageIds}
                            customTitle={cardImageSelectorCustomTitle}
                            immHireCardImageSelector={immHireCardImageSelector}
                            onChange={(id) => contractBuilder[component.onChange](id, localState.card_details, updateCardDetails)}
                            tealiumEventCategory={tealiumEventCategory}
                        />
                    );

                case 'card-pin-change':
                    let hireCardPinSet = null;

                    if (isSetPinEnabled) {
                        const showError = localState.card_details.find(
                            cardDetailsItem => cardDetailsItem.id === 'card_pin_change'
                        ).showError;

                        hireCardPinSet = (
                            <HireCardPinSet
                                immHireCardPinSet={immHireCardPinSet}
                                onBlur={(isValid) => contractBuilder[component.onBlur](isValid, localState.card_details, updateCardDetails)}
                                showError={showError}
                                tealiumEventCategory={tealiumEventCategory}
                            />
                        );
                    }

                    return hireCardPinSet;
                case 'interest-band': {
                    const { localState, contractWizard } = this.props
                    const isDepositRenewal = contractWizard.get('name_contract') === CONTRACT_INDEX_DEPOSIT_RENEWAL

                    const interest = contractWizard.get('interest').toJS()
                    const showInterest = immFlagBasedFeatures.get(DEPOSITS_INTEREST_BAND_COUNTRIES)
                    let expiration = null

                    const tin = localState.card_details.find((element) => element.id === 'tin').value;
                    const tae = localState.card_details.find((element) => element.id === 'tae').value;

                    if (isDepositRenewal) {
                        const dateStart = (localState.card_details.find((element) => element.id === 'startDate') || {}).originalValue;
                        expiration = DateHelper.getDateWithMonthName(dateStart)
                    } else {
                        expiration = (localState.card_details.find((element) => element.id === 'expiration') || {}).value;
                    }

                    if (!showInterest || interest.calculatedInterest === null) {
                        return null
                    }

                    const tinFormatted = formatInterest(tin)
                    const taeFormatted = formatInterest(tae)
                    const originCountry = immProfileFields.get('originCountry')

                    let grossInterest = null

                    if (NL === originCountry) {
                        grossInterest = `${EURO_SYMBOL} ${formatAmount(interest.calculatedInterest)}`;
                    } else {
                        grossInterest = `${formatAmount(interest.calculatedInterest)} ${EURO_SYMBOL}`;
                    }

                    return (
                        <InterestBand
                            tin={tinFormatted}
                            tae={taeFormatted}
                            date={expiration}
                            grossInterest={grossInterest}
                            originCountry={originCountry}
                            showStartDateLabel={isDepositRenewal}
                        />
                    )
                }
                default:
                    return null;
            }
        } else {
            return null;
        }
    }

    executeExtraCall(component, selectedValue) {
        const { functionName } = component.executeExtraCall;
        const {
            getProfessionCnaeCategoryItem,
            getSectorItem
        } = this.props;
        const extraFunctions = {
            'getProfessionCnaeCategoryItem': getProfessionCnaeCategoryItem,
            'getSectorItem': getSectorItem
        }
        extraFunctions[functionName](selectedValue.value, component.id);
    }

    handleAddTaxCountry(index, params) {
        const { updateCardDetails, localState } = this.props;
        const component = {
            id_component: 'tax-additional-country',
            id: 'tax-additionalcountries',
            label: 'contractsView-juniorAccountTaxCountry',
            type: 'form',
            target: 'junior_form_tax_data',
            sourceCountries: 'juniorAccount_loadCmbCountryBirth',
            sourceTaxReasons: 'juniorAccount_loadCmbTaxReason',
            labelCountry: 'contractsView-juniorAccountTaxCountry',
            labelTaxReason: 'contractsView-juniorAccountTaxReason',
            labelTinCode: 'contractsView-juniorAccountTaxTinCode',
            msg_error: '',
            visible: {
                target: 'junior_form_tax_data.radio_obligaciones_fiscales',
                value: [1]
            }
        };
        const targetValue = Immutable.fromJS(
            formHelper.getFieldInTarget(Immutable.fromJS(localState.card_details), component.id)
        );
        const existValue = formHelper.getFieldInTarget(
            Immutable.fromJS(localState.card_details),
            'tax-additionalcountries'
        );
        let saveValue;
        if (targetValue.size > 0) {
            const valueToAdd = {
                paisTributacion: params.countryCode,
                indTipoTributacion: params.taxingReasonCode,
                tin: { codigodocumpersonacorp: params.taxingCountryDocumentID }
            };
            saveValue = existValue.toJS().value;
            saveValue.push(valueToAdd);
        } else {
            saveValue = [
                {
                    paisTributacion: params.countryCode,
                    indTipoTributacion: params.taxingReasonCode,
                    tin: { codigodocumpersonacorp: params.taxingCountryDocumentID }
                }
            ];
        }

        const values = [
            {
                target: {
                    name: 'tax-additionalcountries',
                    value: saveValue
                }
            }
        ];

        values.forEach(item => {
            const retState = formHelper.handleFormElementData(
                item,
                component,
                localState.card_details
            );
            this.setState({ card_details: retState });
        });
        updateCardDetails(localState.card_details);
    }

    handleAfterChange(component, value) {
        const { updateCardDetails, localState: { card_details: cardDetails } } = this.props;
        // Call function:
        //values is an array with object target - value
        let val = get(value, 'target.value', value);
        val = Number.isNaN(val) ? '' : String(val).replace(/\./g, '');
        const values = contractBuilder[component.onChangeFn](val, component, cardDetails);

        values.forEach(item => {
            cardDetails.find(element => element.id === item.target).value = val;
        });

        updateCardDetails(cardDetails);
    }

    handleAmountChange(component, amount) {
        const { updateCardDetails, localState } = this.props;
        const values = contractBuilder[component.onChangeFn](amount);
        values.forEach(item => {
            localState.card_details.filter(x => x.id === item.target)[0].value = item.value;
        });
        updateCardDetails(localState.card_details);
    }

    handleAmountChangeForm(component, amount) {
        //TODO: Remove all this
        if (amount > 100) {
            return component.target;
        }
    }

    handleBlur(component, evt) {
        const { updateCardDetails, contractWizard, localState, requestJuniorProductData } = this.props;
        const cardDetails = localState.card_details;
        const isDocumentField =
            component.id === 'input_number_documents' || component.id === 'input-number-documents';
        const componentState = contractBuilder[component.onBlurFn](evt, component, cardDetails);
        if (isDocumentField) {
            this.handleDocumentBlur(component, evt, cardDetails);
            if (contractWizard.get('name_contract') === 'junior-account') {
                requestJuniorProductData(evt.target.value);
            }
        }
        formValidationHelper.validateComponent(
            componentState,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );
        updateCardDetails(componentState);
        fiocPepNameTagging(component.id);
    }

    handleChange(component, evt) {
        const { updateCardDetails, setInProgress, contractWizard, localState } = this.props;
        const value = evt.label ? evt.label : evt.value;
        const componentState = contractBuilder[component.onChangeFn](
            evt,
            component,
            localState.card_details
        );
        formValidationHelper.validateComponent(
            componentState,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );
        setInProgress();
        updateCardDetails(componentState);

        fiocSelectProfessionTagging({ id:  component.id, value });
    }

    handleCloseHolderModal(component) {
        const { updateCardDetails, localState: { card_details: cardDetails } } = this.props;
        const tabsHolderValue = {
            openModal: false,
            index: null
        };
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.component_id
        ).value = tabsHolderValue;

        updateCardDetails(cardDetails);
    }

    handleCmb(component, cmbSelected) {
        const { updateCardDetails, contractWizard, localState } = this.props;
        let { card_details: cardDetails } = localState;
        let values;

        if (component.onChangeFn) {
            values = contractBuilder[component.onChangeFn](cmbSelected, component, cardDetails);
        } else {
            values = [
                {
                    target: {
                        name: component.id,
                        value: cmbSelected.value
                    }
                }
            ];
        }

        if (component.addFunction) {
            cardDetails = contractBuilder[component.addFunction.lib](
                cmbSelected.value,
                component,
                cardDetails
            );
        }

        if (component.executeExtraCall) {
            this.executeExtraCall(component, cmbSelected);
        }

        values.forEach(item => {
            const target = cardDetails.find(cardDetailsItem => cardDetailsItem.id === item.target);
            if (target && component.type === 'single') {
                target.value = item.value;
            } else if (component.type === 'form') {
                const retState = formHelper.handleFormElementData(item, component, cardDetails);
                this.setState({ card_details: retState });
            }
        });

        if (!component.skipImmediateValidation) {
            formValidationHelper.validateComponent(
                cardDetails,
                component,
                contractWizard.get('steps'),
                contractWizard.get('visibleStep')
            );
        }

        updateCardDetails(cardDetails);
        fiocSelectTagging({ id: component.id, value: cmbSelected.label });
    }

    handleDateTimePickerCallback(component, evt = '') {
        const { updateCardDetails, contractWizard, localState } = this.props;
        const componentState = contractBuilder[component.onChangeFn](
            evt,
            component,
            localState.card_details
        );
        formValidationHelper.validateComponent(
            componentState,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );
        updateCardDetails(componentState);
    }

    handleDeleteTaxCountry(index) {
        const { deleteAdditionalCountry, localState } = this.props;
        const component = {
            id_component: 'tax-additional-country',
            id: 'tax-additionalcountries',
            label: 'contractsView-juniorAccountTaxCountry',
            type: 'form',
            target: 'junior_form_tax_data',
            sourceCountries: 'juniorAccount_loadCmbCountryBirth',
            sourceTaxReasons: 'juniorAccount_loadCmbTaxReason',
            labelCountry: 'contractsView-juniorAccountTaxCountry',
            labelTaxReason: 'contractsView-juniorAccountTaxReason',
            labelTinCode: 'contractsView-juniorAccountTaxTinCode',
            msg_error: '',
            visible: {
                target: 'junior_form_tax_data.radio_obligaciones_fiscales',
                value: [1]
            }
        };
        const existValue = formHelper.getFieldInTarget(
            Immutable.fromJS(localState.card_details),
            'tax-additionalcountries'
        );
        let saveValue;
        saveValue = existValue.toJS().value;
        saveValue.splice(index, 1);

        const newCountries = {
            target: {
                name: 'tax-additionalcountries',
                value: saveValue
            }
        };

        const retState = formHelper.handleFormElementData(
            newCountries,
            component,
            localState.card_details
        );
        this.setState({ card_details: retState });
        deleteAdditionalCountry(saveValue);
    }

    handleDocumentBlur(component, evt, cardDetails) {
        let value = evt.target.value;
        const documentType = cardDetails
            .find(form => form.id === component.target)
            .value.find(element => element.id === 'cmb_tipo_documento').value;

        if (
            documentType === DOCUMENT_TYPE_NIF &&
            value !== '' &&
            value.length < DOCUMENT_TYPE_NIF_LENGTH
        ) {
            value = padLeft(value, DOCUMENT_TYPE_NIF_LENGTH, '0');
        }
        evt.target.value = value.toUpperCase();
    }

    handleInputChange(component, event) {
        const { updateCardDetails, localState } = this.props;
        const cardDetails = localState.card_details;
        const componentState = contractBuilder[component.onBlurFn](event, component, cardDetails);
        updateCardDetails(componentState);
    }

    handleOKButtonClick(component) {
        const { updateCardDetails, localState } = this.props;
        const eventState = contractBuilder[component.onClickFn](localState.card_details);
        if (eventState) {
            this.setState({ eventState });
            updateCardDetails(localState.card_details);
        }
    }

    handleOpenHolderModal(component, index) {
        const { updateCardDetails, localState } = this.props;
        const cardDetails = localState.card_details;
        const tabsHolderValue = {
            openModal: true,
            index: index
        };
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.component_id
        ).value = tabsHolderValue;

        updateCardDetails(cardDetails);
    }

    handleRadioButtonChange(component, value) {
        const {
            contractWizard,
            getOpenYoungProfileDetails,
            localState,
            updateCardDetails,
        } = this.props;
        let cardDetails = localState.card_details;
        const target = cardDetails.find(cardDetailsItem => cardDetailsItem.id === component.target);
        let element;

        if (component.onChangeFn) {
            cardDetails = contractBuilder[component.onChangeFn](value, component, cardDetails);
        }

        if (contractWizard.get('name_contract') === 'junior-account' &&
            component.id === 'juniorAccount_cardOwner') {
            getOpenYoungProfileDetails(value);
        }

        if (component.type === 'form') {
            element = target.value.find(targetItem => targetItem.id === component.id);
            if (!element) {
                element =
                    target.value[
                    target.value.push({
                        id: component.id
                    }) - 1
                        ];
            }
        } else {
            element = target;
        }
        element.value = Number(value);

        this.setState({ card_details: cardDetails });
        formValidationHelper.validateComponent(
            cardDetails,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );
        updateCardDetails(cardDetails);
        fiocSelctKnowYourCNAE({ id: component.id, value })
    }

    handleRegexOnKeyPressAndPaste(component, event) {
        const regex = component.regex;
        const regexText = event.clipboardData
            ? event.clipboardData.getData('text/plain')
            : String.fromCharCode(event.charCode);

        if (regex && !regex.test(regexText) && !event.ctrlKey) {
            event.preventDefault();
        }
    }

    handleRemoveHolder(component) {
        const { contractWizard, updateCardDetails, removeIntervener, localState } = this.props;
        const prefix = component.prefix;
        let cardDetails = localState.card_details;
        let tabsHolderValue = cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.component_id
        ).value;
        let data = cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.idComponentHolder
        ).value;
        const newData = data[1].filter((_, i) => i !== tabsHolderValue.index);

        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.idComponentHolder
        ).value[1] = newData;
        removeIntervener(tabsHolderValue.index + 1, contractWizard.get('interveners'));

        cardDetails = this.removeHolder(
            cardDetails,
            prefix,
            data[1].length + 1,
            tabsHolderValue.index + 1
        );

        tabsHolderValue = {
            openModal: false,
            index: null
        };
        cardDetails.find(
            cardDetailsItem => cardDetailsItem.id === component.component_id
        ).value = tabsHolderValue;

        updateCardDetails(cardDetails);
    }

    handleSelectOnBlur(component) {
        const { contractWizard, localState: { card_details: state }, updateCardDetails } = this.props;
        const { onBlurValidateFn } = component;
        let validate = true;
        if (onBlurValidateFn) {
            validate = contractBuilder[onBlurValidateFn](component, state);
        }

        validate && formValidationHelper.validateComponent(
            state,
            component,
            contractWizard.get('steps'),
            contractWizard.get('visibleStep')
        );

        updateCardDetails(state);
    }

    handleSelectedCard(cardImage) {
        const { localState, setCardImage } = this.props;
        localState.card_details.find(
            cardDetailsItem => cardDetailsItem.id === 'card_image'
        ).value = cardImage;
        setCardImage(cardImage);
    }

    removeHolder(cardDetails, prefix, holdersNumber, removeIndex) {
        for (let holderIndex = removeIndex; holderIndex <= holdersNumber; holderIndex++) {
            const prefixRegexp = new RegExp(prefix.replace('#N#', holderIndex), 'g');
            cardDetails = cardDetails.map(detail => {
                if (prefixRegexp.test(detail.id)) {
                    if (holderIndex === holdersNumber) {
                        detail.value = null;
                    } else {
                        const nextHolderDetailId = detail.id.replace(
                            prefix.replace('#N#', holderIndex),
                            prefix.replace('#N#', holderIndex + 1)
                        );
                        const nextHolderDetail = cardDetails.find(
                            detail => detail.id === nextHolderDetailId
                        );
                        detail.value = nextHolderDetail && nextHolderDetail.value;
                    }
                }
                return detail;
            });
        }

        return cardDetails;
    }

    shouldBuildComponent(component) {
        const { contractWizard } = this.props;
        const card_details = contractWizard.get('card_details');
        const shouldBuild =
            !component.buildCondition ||
            contractBuilder[component.buildCondition](contractWizard, component);
        return shouldBuild && formHelper.componentVisibility(card_details, component);
    }

    updatePersonalData(newData, cardDetails, prefix) {
        let newPrefix = '';
        if (newData) {
            newData.map((item, index) => {
                newPrefix = prefix.replace('#N#', index + 1);
                cardDetails.find(
                    cardDetailsItem => cardDetailsItem.id === `${newPrefix}full_name`
                ).value = {
                    firstName: item.firstName,
                    lastName: item.lastName,
                    secondlastName: item.secondlastName,
                    identificationValue: item.identificationValue
                };
                cardDetails.find(
                    cardDetailsItem => cardDetailsItem.id === `${newPrefix}document_type`
                ).value = item.identificationType
                    ? formatText(`contractsView-identificationType${item.identificationType}`)
                    : '';
                cardDetails.find(
                    cardDetailsItem => cardDetailsItem.id === `${newPrefix}document_number`
                ).value =
                    item.identificationValue;
            });
        }

        return cardDetails;
    }

    validateIfShowOwnerAuthorized(component, holder) {

        return (
            (!component.showInTitular && !component.showInIntevenierAuthorized) ||
            (component.showInTitular && holder.accountRelation === ACCOUNT_INTERVENTION_OWNER_CODE) ||
            (component.showInIntevenierAuthorized && holder.accountRelation === ACCOUNT_INTERVENTION_AUTHORIZED_CODE)
        );
    }

    render() {
        const { component } = this.props;
        const content = this.doBuild(component);
        return content;
    }
}

ContractComponent.propTypes = {
    contractWizard: PropTypes.object.isRequired,
    component: PropTypes.object.isRequired,
    localState: PropTypes.object,
    current_contract: PropTypes.object,
    updateCardDetails: PropTypes.func,
    flagBasedFeatures: PropTypes.object.isRequired,
    getContractInformation: PropTypes.func,
    getContractInformationWithPricing: PropTypes.func,
    requestAds: PropTypes.func.isRequired,
    immProfileFields: PropTypes.object,
    immCommercialAds: PropTypes.object,
    immDeposits: PropTypes.object,
    immHireCardImageSelector: PropTypes.object.isRequired,
    immHireCardPinSet: PropTypes.object.isRequired,
    isInactiveAccountsEnabled: PropTypes.bool.isRequired,
    dropdownAccountsActions: PropTypes.object,
    addSimpleIntervener: PropTypes.func,
    clearInterveners: PropTypes.func,
    immAccounts: PropTypes.object,
    immCards: PropTypes.object,
    immHiringProductInformation: PropTypes.object,
    accountId: PropTypes.string,
    location: PropTypes.object,
    setCardImage: PropTypes.func.isRequired,
    setIntervenerType: PropTypes.func.isRequired,
    addIntervener: PropTypes.func.isRequired,
    removeIntervener: PropTypes.func.isRequired,
    restoreDefaultInterveners: PropTypes.func.isRequired,
    requestInterveners: PropTypes.func.isRequired,
    requestDepositsInterest: PropTypes.func.isRequired,
    requestIntervenersSpecial: PropTypes.func.isRequired,
    requestAccountsSpecial: PropTypes.func.isRequired,
    changeIntervenerRelationship: PropTypes.func.isRequired,
    excludeIntervener: PropTypes.func.isRequired,
    setAccount: PropTypes.func,
    nextStep: PropTypes.func,
    closeModal: PropTypes.func,
    setInProgress: PropTypes.func,
    deleteAdditionalCountry: PropTypes.func,
    requestReferenceStandard: PropTypes.func,
    getProfessionCnaeCategoryItem: PropTypes.func.isRequired,
    getSectorItem: PropTypes.func.isRequired,
    getOpenYoungProfileDetails: PropTypes.func.isRequired,
    getHiringProductInformation: PropTypes.func,
    preContractualMail: PropTypes.object,
    updateConfirmationCheckboxes: PropTypes.func.isRequired,
    sendPreContractualMail: PropTypes.func.isRequired,
    requestProfile: PropTypes.func.isRequired,
    requestJuniorProductData: PropTypes.func.isRequired,
    setAllAccountsToInactive: PropTypes.func,
    gestorCrossEnabled: PropTypes.bool,
    hireAccountPassportOrFutureMode: PropTypes.bool,
    tealiumEventCategory: PropTypes.string,
    isSetPinEnabled: PropTypes.bool.isRequired,
    setTermsAndCondsText: PropTypes.func.isRequired,
    immFlagBasedFeatures: PropTypes.object,
    disableFinishButton: PropTypes.func,
    updateSimpleIntervener: PropTypes.func,
    updateDepositProduct: PropTypes.func,
    preContractualMailPolling: PropTypes.object,
    requestNewMoneyDepositHireInformation: PropTypes.func,
    onLegalTextRead: PropTypes.func,
    refreshMainNoNewMoneyDepositHireInformation: PropTypes.func.isRequired,
    refreshMainBonifiedNoNewMoneyDepositHireInformation: PropTypes.func.isRequired,
    refreshNewMoneyDepositHireInformation: PropTypes.func.isRequired,
    refreshNewMoneyDepositHireInformationDepositDropdown: PropTypes.func.isRequired,
    refreshMainNoNewMoneyDepositHireInformationDepositDropdown: PropTypes.func.isRequired,
    refreshMainBalanceNoNewMoneyDepositHireInformationDepositDropdown: PropTypes.func.isRequired,
    termsAndCondsLegalWindowSetParams: PropTypes.func.isRequired,
    match: PropTypes.object.isRequired
};

module.exports.constructor = ContractComponent;
module.exports.ContractComponent = connect(state => ({
    immFlagBasedFeatures: state.flagBasedFeatures,
    immPrecontractualDocumentation: state.preContractualPolling,
    immMergePDFDocuments: state.precontractualsMergePdfs,
}), {
    deleteAdditionalCountry: contractsActions.deleteAdditionalCountry,
    setInProgress: contractsActions.setInProgress,
    setCardImage: contractsActions.setCardImage,
    addSimpleIntervener: contractsActions.addSimpleIntervener,
    requestAds: commercialAdsAction.requestAds,
    requestReferenceStandard: contractsActions.requestReferenceStandard,
    clearInterveners: contractsActions.clearInterveners,
    getContractInformation: contractsActions.getContractInformation,
    getContractInformationWithPricing: contractsActions.getContractInformationWithPricing,
    getDocumentsOkApiById:okApiDocuments.getDocumentsOkApiById,
    getHiringProductInformation: hiringProductInformation.getHiringProductInformation,
    updateCardDetails: contractsActions.updateCardDetails,
    updateDepositProduct: contractsActions.updateDepositProduct,
    setIntervenerType: contractsActions.setIntervenerType,
    addIntervener: contractsActions.addIntervener,
    refreshDepositEighteenHireInformation: hireDepositEighteenMonths.refreshDepositEighteenHireInformation,
    refreshNewMoneyDepositHireInformation: hireNewMoneyDeposit.refreshNewMoneyDepositHireInformation,
    refreshNoNewMoneyDepositHireInformation: hireNoNewMoneyDeposit.refreshNoNewMoneyDepositHireInformation,
    refreshDeposit13MonthsExcepcionesHireInformation: hireDepositThirteenMonths.refreshDeposit13MonthsExcepcionesHireInformation,
    refreshDeposit13MonthsLeakRetentionHireInformation: hireDepositThirteenMonths.refreshDeposit13MonthsLeakRetentionHireInformation,
    refreshDeposit13MonthsDueDatesHireInformation: hireDepositThirteenMonths.refreshDeposit13MonthsDueDatesHireInformation,
    refreshDeposit13MonthsLinkedMaturitiesHireInformation: hireDepositThirteenMonths.refreshDeposit13MonthsLinkedMaturitiesHireInformation,
    refreshDeposit13MonthsRenovacionExcepcionesHireInformation: hireDepositThirteenMonths.refreshDeposit13MonthsRenovacionExcepcionesHireInformation,
    removeIntervener: contractsActions.removeIntervener,
    restoreDefaultInterveners: contractsActions.restoreDefaultInterveners,
    requestInterveners: intervenersActions.requestAccountInterveners,
    requestIntervenersSpecial: contractsActions.requestIntervenersSpecial,
    requestAccountsSpecial: contractsActions.requestAccountsSpecial,
    requestDepositsInterest: contractsActions.requestDepositsInterest,
    requestNewMoneyDepositHireInformation: hireNewMoneyDeposit.requestNewMoneyDepositHireInformation,
    refreshNewMoneyDepositHireInformationDepositDropdown: hireNewMoneyDeposit.refreshNewMoneyDepositHireInformationDepositDropdown,
    refreshMainNoNewMoneyDepositHireInformation: hireMainNoNewMoneyDeposit.refreshMainNoNewMoneyDepositHireInformation,
    refreshMainBonifiedNoNewMoneyDepositHireInformation: hireMainNoNewMoneyDeposit.refreshMainBonifiedNoNewMoneyDepositHireInformation,
    refreshMainNoNewMoneyDepositHireInformationDepositDropdown: hireMainNoNewMoneyDeposit.refreshMainNoNewMoneyDepositHireInformationDepositDropdown,
    refreshMainBalanceNoNewMoneyDepositHireInformationDepositDropdown: hireMainNoNewMoneyDeposit.refreshMainBalanceNoNewMoneyDepositHireInformationDepositDropdown,
    termsAndCondsLegalWindowSetParams: termsAndCondsLegalWindowActions.termsAndCondsLegalWindowSetParams,
    setTermsAndCondsDic: termsAndCondsLegalWindowActions.setTermsAndCondsDic,
    setAcceptDocument: termsAndCondsLegalWindowActions.setAcceptDocument,
    toggleInfoModal: contractsActions.toggleInfoModal,
    changeIntervenerRelationship: contractsActions.changeIntervenerRelationship,
    excludeIntervener: contractsActions.excludeIntervener,
    setAccount: contractsActions.setAccount,
    getOpenYoungProfileDetails: contractsActions.getOpenYoungProfileDetailsForContract,
    getProfessionCnaeCategoryItem: contractsActions.getProfessionCnaeCategoryItem,
    getSectorItem: contractsActions.getSectorItem,
    requestJuniorProductData: contractsActions.requestJuniorProductData,
    setAllAccountsToInactive: contractsActions.setAllAccountsToInactive,
    updateSimpleIntervener: contractsActions.updateSimpleIntervener,
    getPrecontractualDocumentURLOrID: contractsActions.getPrecontractualDocumentURLOrID,
    getPreContractualDocumentationList: precontractualActions.getPreContractualDocumentationList
})(ContractComponent);
